define('viewmodels/Calculations/QuantConfig',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings', 'services/utils', 'viewmodels/configuration/InherentSetup'], function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings, utils, InherentSetup) {
    var title = 'Heat Map';

    var HmViewModel = {
        activate: activate,
        attached: attached,
        detached: detached,
        title: title,
        utils: utils,
        appsecurity: appsecurity,
        InherentSetup: InherentSetup,
        saveRiskAreaPopUp: saveRiskAreaPopUp,   // To add a new TAB
        OpenRiskAreaPopup: OpenRiskAreaPopup,
        addPopUpCss: ko.observable(true),
        editPopUpCss: ko.observable(true),
        EditAreaVisible: ko.observable(false),
        EditFactorVisible: ko.observable(false),
        EditSubFactorVisible: ko.observable(false),
        CurrentRiskFactorType: ko.observable(),
        SubFactorAssessmentTypeList: ko.observableArray([]),
        SelectedAssessmentTypeSubFactor: ko.observable(),
        SelectedAssessmentTypeSubFactorEdit: ko.observable(),
        RiskAreaSortOrder: ko.observable(),
        RiskFactorSortOrder: ko.observable(),
        RiskSubFactorSortOrder: ko.observable(),
        RiskAreaId: ko.observable(),
        SaveRiskSubFactorSortOrder: SaveRiskSubFactorSortOrder,
        DownFunctionalityRiskArea: DownFunctionalityRiskArea,
        UpFunctionalityRiskArea: UpFunctionalityRiskArea,
        UpFunctionalityRiskFactor: UpFunctionalityRiskFactor,
        UpFunctionalityRiskSubFactor: UpFunctionalityRiskSubFactor,
        SaveRiskFactorSortOrder: SaveRiskFactorSortOrder,
        CancelRiskFactorSortOrder: CancelRiskFactorSortOrder,
        CancelRiskSubFactorSortOrder: CancelRiskSubFactorSortOrder,

        DownFunctionalityRiskFactor: DownFunctionalityRiskFactor,
        DownFunctionalityRiskSubFactor: DownFunctionalityRiskSubFactor,
        OpenRiskSubFactorOrderPopup: OpenRiskSubFactorOrderPopup,
        popUpTitle: ko.observable(),
        editableRiskArea: ko.observable(),
        RiskFactorList: ko.observableArray(),
        SelectedRiskAreaDetails: ko.observableArray(),
        SurveyDetailsList: ko.observableArray(),
        RiskAreaList: ko.observableArray(),
        RiskAreaReorderList: ko.observableArray(),
        RiskAreaReorderListDup: ko.observableArray(),
        RiskFactorReorderList: ko.observableArray(),
        RiskFactorReorderListDup: ko.observableArray(),
        RiskSubFactorReorderList: ko.observableArray(),
        RiskSubFactorReorderListDup: ko.observableArray(),
        FactorAssessmentTypeList: ko.observableArray(),
        FactorAssessmentTypeListModified: ko.observableArray(),
        SaveRiskAreaSortOrder: SaveRiskAreaSortOrder,
        CancelRiskAreaSortOrder: CancelRiskAreaSortOrder,
        OpenRiskAreaOrderPopup: OpenRiskAreaOrderPopup,
        OpenRiskFactorOrderPopup: OpenRiskFactorOrderPopup,
        deleteRiskAreafunction: deleteRiskAreafunction,
        deleteRiskArea: deleteRiskArea,
        ShowFactorPopUp: ShowFactorPopUp,
        editableRiskFactor: ko.observable(),
        saveRiskFactorPopUpButton: saveRiskFactorPopUpButton,
        editFunctionalityRF: editFunctionalityRF,
        deleteFunctionalityRF: deleteFunctionalityRF,
        editRiskAreaFunction: editRiskAreaFunction,
        trclick: trclick,
        RiskSubFactorsList: ko.observableArray(),
        addRiskSubFactorFunctionality: addRiskSubFactorFunctionality,
        deleteRiskSubFactorFunctionality: deleteRiskSubFactorFunctionality,
        editRiskSubFactorFunctionality: editRiskSubFactorFunctionality,
        RiskFactorId: ko.observable(),
        AMLRiskLevel: ko.observable(),
        SANCRiskLevel: ko.observable(),
        editableRiskSubFactor: ko.observable(),
        AMLRiskLevelDrpDwnList: ko.observableArray(),
        RiskScoreDrpDwnList: ko.observableArray(),
        SanctionRiskLevelDrpDwnList: ko.observableArray(),
        saveRsfButton: saveRsfButton,
        cancelRsfButton: cancelRsfButton,
        rsfPopUpTitle: ko.observable(),
        valueAML: ko.observable(),
        valueSANC: ko.observable(),
        valueAMLScore: ko.observable(),
        valueSANCScore: ko.observable(),
        ControlsAccess: ko.observable(false),
        AssessmentTypeFactor: ko.observable(),
        AssessmentTypeSubFactor: ko.observable(),
        AssessmentTypeSubFactorParent: ko.observable(),
        AssessmentTypeSubFactorDisabled: ko.observable(true),
        AssessmentTypeFactorDisabled: ko.observable(true),
        AssessmentTypeAreaDisabled: ko.observable(true),
        CurrentRiskAreaId: ko.observable(),
        CurrentRiskAreaType: ko.observable(),
        AMLNumbering: ko.observable(),
        SANCNumbering: ko.observable(),
        AMLRSFNumbering: ko.observable(),
        SANCRSFNumbering: ko.observable(),
        AMLScoreVisible: ko.observable(false),
        SANCScoreVisible: ko.observable(false),
        SelectedAssessmentType: ko.observableArray([]),
        SelectedLanguageType: ko.observableArray([]),
        // RiskScoreDrpDwnList: ko.observableArray(),
        AssessmentTypeList: ko.observable(),//addedd to host the assessment type data
        CurrentScreenName: ko.observable(''),
        getIRSdata: getIRSdata, // added for subfactor risk socre
        setTriggerAttach: true,
        FreezeConfigurationsByScreen: FreezeConfigurationsByScreen,
        RiskAreaTypeUI: ko.observable(),
        OpenConfigureResponseTypePopup: OpenConfigureResponseTypePopup,
        deleteResponseItem: deleteResponseItem,
        deleteResponseButton: deleteResponseButton,
        SaveResponseType: SaveResponseType,
        editableResponseType: ko.observable(),
        Avgtyperdbchanged: Avgtyperdbchanged,
        responsepapplicabilityclick: responsepapplicabilityclick,
        GetQuanResponseColumnDetails: GetQuanResponseColumnDetails,
        ValidateResponses: ValidateResponses,
        WeightedAverageType: ko.observable(false),
        ActionChanged: ActionChanged,
        ApplicabilityRelHeaderEvent: ApplicabilityRelHeaderEvent,
        SelectedAssessmentTypeFactor: ko.observableArray([]),
        SelectedAssessmentTypeFactorEdit: ko.observableArray([]),
        ObjGeneralSettings: ObjGeneralSettings,
        LanguageList: ko.observableArray(),
        LanguageAdded: LanguageAdded,
        RiskAreaSubList: ko.observableArray(),
        LanguageDropdownVisible: ko.observable(true),
        editableResponseTypes: ko.observableArray(),
        isGlobalFlag: ko.observable(),
        AddResponseType: AddResponseType,
        ApplicabilityChanged: ApplicabilityChanged,
        AssessmentType: ko.observable(),
        AssessmentTypeColumnList: ko.observableArray(),
        FactorWeightedAverageType: ko.observable(),
        assessmentSelected: ko.observable(false),
        editableResponseTypesForFactor: ko.observableArray(),
        AvgtyperdbchangedFactor: AvgtyperdbchangedFactor,
        LanguageddFactorVisible: ko.observable(true),
        SelectedLanguageFactorType: ko.observableArray([]),
        LanguageFactorAdded: LanguageFactorAdded,
        FactorRiskAreaList: ko.observableArray(),
        ObjFactorRiskAreaList: ko.observableArray(),
        GetFactorQuanResponseAndLanguages: GetFactorQuanResponseAndLanguages,
        GetRiskFactorLangList: GetRiskFactorLangList,
        UpdateRiskAreaLangList: ko.observableArray(),
        SelectedLanguageSubFactorType: ko.observableArray([]),
        LanguageSubFactorAdded: LanguageSubFactorAdded,
        SubFactorRiskAreaList: ko.observableArray(),//sub factor
        SubFactorAddAreaList: ko.observableArray(),//sub factor
        InherentRiskLevelList: ko.observableArray(),
        InherentRiskLevelListDup: ko.observableArray(),
        calculationFactor: ko.observable(true),
        InputChangedArea: InputChangedArea,
        InputChangedFactor: InputChangedFactor,
        InputChangedSubFactor: InputChangedSubFactor,
        isGlobalFlagChange: isGlobalFlagChange,
        SimpleAverageType: ko.observable(false),
        BulkUploadPopup: BulkUploadPopup,
        BulkUploadQuantTemplateDownload: BulkUploadQuantTemplateDownload,
        UploadFileSize: ko.observable(20145728),
        UploadExcelDocument: UploadExcelDocument,
        RiskAreaName: ko.observable(),
        QuestionTypeChangedSubFactor: QuestionTypeChangedSubFactor,
        HeaderSubFactorType: ko.observable(),
        resetRadioButtons: resetRadioButtons,
        SubfactorQuestionType: ko.observable(null),
        HeaderTypeSubFactor: ko.observable(false),

        //Inherent Setup
        RATActionChanged: RATActionChanged,
        RATActionChangedEdit: RATActionChangedEdit,
        InherentSetupQuantObj: ko.observableArray([]),
        ZATRATList: ko.observableArray([]),
        ZATRATListDup: ko.observableArray([]),
        ZATRATListLength: ko.observable(),
        ZATDropDownList: ko.observableArray([]),
        SelectedZATDropDownList: ko.observableArray([]),
        SelectedZATRATList: ko.observableArray([]),
        SelectedAssessmentTypeEdit: ko.observableArray([]),
        SelectedZATDropDownListEdit: ko.observableArray([]),
        AssessmentTypeListModified: ko.observableArray([]),
        ZATDropDownListModified: ko.observableArray([]),
        HeaderSubFactorsList: ko.observableArray([]),
        HeaderSubFactorsDropDownList: ko.observableArray([]),
        AddAreaFlag: ko.observable(),
        SurveyGroupShortName: ko.observable(),
        SurveyCategoryList: ko.observableArray([]),
        SurveyCategoryTabClick: SurveyCategoryTabClick,
        SurveyGroupType: ko.observable(),
        ToggleNavigationMenu1: ToggleNavigationMenu1,
        ToggleNavigationMenu2: ToggleNavigationMenu2,
        CollapseAllTreeView: CollapseAllTreeView,
        ExpandAllTreeView: ExpandAllTreeView,

        AreaLeveljstree: ko.observable(),
        HideFilterDiv: HideFilterDiv,
        ShowFilterDiv: ShowFilterDiv,
        SelectedAreaName: ko.observable(),
        BreadCrumbArray: ko.observableArray([]),
        ToggleNavigationMenu1: ToggleNavigationMenu1,
        ToggleNavigationMenu2: ToggleNavigationMenu2,
        CollapseAllTreeView: CollapseAllTreeView,
        ExpandAllTreeView: ExpandAllTreeView,
        hasChildNodes: ko.observable(false),
    };
    HmViewModel.AssessmentTypeSubFactor.subscribe(function (newvalue) {
        if (newvalue) {
            if (HmViewModel.AssessmentTypeSubFactor().toUpperCase() == "BOTH") {
                HmViewModel.AMLScoreVisible(true);
                HmViewModel.SANCScoreVisible(true);
            }
            else if (HmViewModel.AssessmentTypeSubFactor().toUpperCase() == "AML") {
                HmViewModel.AMLScoreVisible(true);
                HmViewModel.SANCScoreVisible(false);
            }
            else if (HmViewModel.AssessmentTypeSubFactor().toUpperCase() == "SANCTIONS" || HmViewModel.AssessmentTypeSubFactor().toUpperCase() == "SANC") {
                HmViewModel.AMLScoreVisible(false);
                HmViewModel.SANCScoreVisible(true);

            }
        }
    });
    return HmViewModel;


    var GetAllRiskAreaAjax = {};
    var GetAllRiskFactorAjax = {};
    var AddRiskAreaAjax = {};
    var GetAllRiskSubFactorsAjax = {};
    var isEdit, isRsfEdit = false;


    function activate(DataObj) {
        try {

            //$('#adddivtab').on('click', function () {
            //});
            //HmViewModel.InherentSetupQuantObj(DataObj.InherentSetupQuantObj);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
            self.SurveyType = ko.observable(item.SurveyType);
            self.Applicability = ko.observable(item.Applicability);
            self.SurveyGroupId = ko.observable(item.SurveyGroupId);
            self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.IsEditable = ko.observable(item.IsEditable);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }
    function GetSurveyCategoryTabs() {
        try {
            $.ajax({
                url: "/api/Configuration/GetSurveyCategoryTabs",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                        var mappedTabList = $.map(jsonResult, function (result) {
                            if (result.SurveyGroupShortName == 'QTDR') {
                                return new SurveyCategoryModel(result);
                            }
                        });
                        $('#loadingMainImgDiv').show();
                        HmViewModel.SurveyCategoryList(mappedTabList);
                        $('#InherentTabDiv').tabs();
                        $('#InherentTabDiv').tabs('refresh');
                        $('#InherentTabDiv').tabs({ active: 0 });
                        $($('#SurveyCategoryTabsDiv li').get(0)).trigger('click');
                        scrollableTabs();
                        $('#PageButtonsDiv').show();
                    }
                    else {
                        if (jsonResult.length === 0 || jsonResult == null) {
                            $('#loadingMainImgDiv').hide();
                            $('#errorComp').show();
                            $('#PageButtonsDiv').hide();
                        }
                        else {
                            $('#loadingMainImgDiv').hide();
                            $('#errorComp').show();
                            $('#PageButtonsDiv').hide();

                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);

                        }
                    }
                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in InherentSetup.js';
                        logger.logMessage(msg);
                    }

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }


    function SurveyCategoryTabClick(data, event) {
        try {
            $('#loadingMainImgDiv').show();
            if (data.SurveyGroupShortName() === 'QTDR') {
                HmViewModel.SurveyGroupType('QTDR');
             //   ko.applyBindingsToNode($('#InnerInherentDiv').children().get(0), { compose: { model: 'viewmodels/configuration/RisksAreasfactors', activationData: { InherentSetupQuantObj: data } } }, HmViewModel);
            }
            else if (data.SurveyGroupShortName() === 'QLDR') {
                HmViewModel.SurveyGroupType('QLDR');
             //   ko.applyBindingsToNode($('#InnerInherentDiv').children().get(0), { compose: { model: 'viewmodels/configuration/QualitativeSetup', activationData: { InherentSetupQualObj: data } } }, HmViewModel);
            }
            $('#loadingMainImgDiv').hide();
            GetAllSurveyCategories().then(function () {
                $('#loadingMainImgDiv').show();
                HmViewModel.SurveyGroupShortName('QTDR');
                if (appsecurity.WriteAccess()) {
                    //if (HmViewModel.appsecurity.FinalConfigurationSave())
                    //    HmViewModel.ControlsAccess(false);
                    //else
                    HmViewModel.ControlsAccess(true);
                }
                else {
                    HmViewModel.ControlsAccess(false);
                }

               // GetConfigurationFreezeStatusByScreen();
                $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
                $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');
                GetAllAssessmentTypes();
                
                GetQuanResponseColumnDetails();
            });
         
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClick() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            GetSurveyCategoryTabs();
        

            $("#adddivtabdiv").tabs();


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    function RATActionChanged(data, event) {
        try {
            var selectedassessmentsType = [];
            selectedassessmentsType = HmViewModel.SelectedAssessmentType();
            HmViewModel.ZATDropDownList([]);
            var MappedList = [];
            for (var j = 0; j < selectedassessmentsType.length; j++) {
                for (var i = 0; i < HmViewModel.ZATRATList().length; i++) {
                    if (selectedassessmentsType[j] === HmViewModel.ZATRATList()[i].RAT_UID() &&
                        HmViewModel.InherentSetupQuantObj().SurveyCategoryId() != HmViewModel.ZATRATList()[i].ZAT_UID()) {
                        if (MappedList.length === 0)
                            MappedList.push(new ZATRATModel(HmViewModel.ZATRATList()[i].ZAT_UID(), HmViewModel.ZATRATList()[i].ZATName(), HmViewModel.ZATRATList()[i].RAT_UID()));
                        else {
                            var countvar = 0;
                            for (var k = 0; k < MappedList.length; k++) {
                                if (MappedList[k].ZAT_UID() === HmViewModel.ZATRATList()[i].ZAT_UID()) {
                                    countvar++;
                                }
                            }
                            if (countvar === 0)
                                MappedList.push(new ZATRATModel(HmViewModel.ZATRATList()[i].ZAT_UID(), HmViewModel.ZATRATList()[i].ZATName(), HmViewModel.ZATRATList()[i].RAT_UID()));
                        }
                    }
                }
            }
            HmViewModel.ZATDropDownList(MappedList);
            $('#ZATApplicability').multiselect();
            $('#ZATApplicability').multiselect('refresh');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RATActionChanged() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    function RATActionChangedEdit(data, event) {
        try {
            var selectedassessmentsType = [];
            for (var i = 0; i < HmViewModel.SelectedAssessmentType().length; i++) {
                selectedassessmentsType.push(HmViewModel.SelectedAssessmentType()[i]);
            }
            for (var i = 0; i < HmViewModel.SelectedAssessmentTypeEdit().length; i++) {
                selectedassessmentsType.push(HmViewModel.SelectedAssessmentTypeEdit()[i]);
            }
            HmViewModel.ZATDropDownListModified([]);
            var MappedList = [];
            for (var j = 0; j < selectedassessmentsType.length; j++) {
                for (var i = 0; i < HmViewModel.ZATRATList().length; i++) {
                    if (selectedassessmentsType[j] === HmViewModel.ZATRATList()[i].RAT_UID() &&
                        HmViewModel.InherentSetupQuantObj().SurveyCategoryId() != HmViewModel.ZATRATList()[i].ZAT_UID()) {
                        if (MappedList.length === 0 &&
                            HmViewModel.SelectedZATDropDownListEdit().indexOf(HmViewModel.ZATRATList()[i].ZAT_UID()) < 0)
                            MappedList.push(new ZATRATModel(HmViewModel.ZATRATList()[i].ZAT_UID(), HmViewModel.ZATRATList()[i].ZATName(), HmViewModel.ZATRATList()[i].RAT_UID()));
                        else {
                            var countvar = 0;
                            for (var k = 0; k < MappedList.length; k++) {
                                if (MappedList[k].ZAT_UID() === HmViewModel.ZATRATList()[i].ZAT_UID()) {
                                    countvar++;
                                }
                            }
                            if (countvar === 0 &&
                                HmViewModel.SelectedZATDropDownListEdit().indexOf(HmViewModel.ZATRATList()[i].ZAT_UID()) < 0)
                                MappedList.push(new ZATRATModel(HmViewModel.ZATRATList()[i].ZAT_UID(), HmViewModel.ZATRATList()[i].ZATName(), HmViewModel.ZATRATList()[i].RAT_UID()));
                        }
                    }
                }
            }
            HmViewModel.ZATDropDownListModified(MappedList);
            $('#ZATApplicabilityModified').multiselect();
            $('#ZATApplicabilityModified').multiselect('refresh');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RATActionChangedEdit() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function ActionChanged(data, event) {
        try {
            if (data.QuestionType() !== "H") {
                if (data.RiskMapping() === "")
                    BindDynamicHtmlForDropDowns();
                else {
                    var RiskMapping = data.RiskMapping();
                    RiskMapping = RiskMapping + "|" + HmViewModel.SelectedAssessmentTypeSubFactor().toString().trim();
                    BindDynamicHtmlForDropDownsEdit(RiskMapping.split('|'));
                }
            }
            ApplicabilityRelHeaderEvent(data, event);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChanged() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    function BindDynamicHtmlForDropDowns() {
        try {
            var selectedassessments = [];
            if (HmViewModel.SelectedAssessmentTypeSubFactorEdit() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactorEdit().length; i++) {
                    selectedassessments.push(HmViewModel.SelectedAssessmentTypeSubFactorEdit()[i]);
                }
            }
            if (HmViewModel.SelectedAssessmentTypeSubFactor() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                    selectedassessments.push(HmViewModel.SelectedAssessmentTypeSubFactor()[i]);
                }
            }
            //var selectedassessments = HmViewModel.SelectedAssessmentTypeSubFactor();
            $('#DynamicScoreDiv').empty();
            var DynamicHTMl = "";
            for (var j = 0; j < selectedassessments.length; j++) {
                for (var i = 0; i < HmViewModel.AssessmentTypeList().length; i++) {
                    if (parseInt(selectedassessments[j]) == HmViewModel.AssessmentTypeList()[i].AssessmentId()) {

                        DynamicHTMl += '<div class="form-group" id="appSubfactor">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">' + HmViewModel.AssessmentTypeList()[i].AssessmentName() + ' Score</label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<select id="' + HmViewModel.AssessmentTypeList()[i].AssessmentId() + '" data-bind="foreach:{data: InherentRiskLevelList, as: \'List1\'}" class="classdoesntexist form-control">' +
                            '<!-- ko if: (List1.AssessmentTypeId ==' + parseInt(selectedassessments[j]) + '|| List1.AssessmentTypeId == 99999)-->' +
                            '<!-- ko if: !(List1.isQuantitative ==0)-->' +
                            '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                            '<option data-bind="text: RiskLevelDescription,value:RiskLevelId"></option>' +
                            '</optgroup>' +
                            '<!--/ko -->' +
                            '<!--/ko -->' +
                            '</select>' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl
            ko.cleanNode(document.getElementById('DynamicScoreDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicScoreDiv"));

            if (HmViewModel.SelectedLanguageSubFactorType().length > 2 || selectedassessments.length > 2) {

                $("#frmSubFactorScroll").css({ "height": "auto", "max-height": "50rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                $("modalContent").css({ "height": "auto", "max-height": "65rem" });
            }
            //else {
            //    $("#frmSubFactorScroll").removeAttr("Style");
            //}
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDowns() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function ApplicabilityRelHeaderEvent(data, event) {
        try {
            var selectedassessments = [];
            if (HmViewModel.SelectedAssessmentTypeSubFactor() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                    selectedassessments.push(HmViewModel.SelectedAssessmentTypeSubFactor()[i].toString().trim());
                }
            }
            if (HmViewModel.SelectedAssessmentTypeSubFactorEdit() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactorEdit().length; i++) {
                    selectedassessments.push(HmViewModel.SelectedAssessmentTypeSubFactorEdit()[i].toString().trim());
                }
            }
            selectedassessments.sort();
            var selectedassessmentsString = "";
            for (var i = 0; i < selectedassessments.length; i++) {
                if (i === 0)
                    selectedassessmentsString += selectedassessments[i].toString().trim();
                else
                    selectedassessmentsString += ',' + selectedassessments[i].toString().trim();
            }
            var MappedHeaderList = [];
            var TempHeaderUID = data.HeaderUID();
            HmViewModel.HeaderSubFactorsDropDownList([]);

            for (var h = 0; h < HmViewModel.HeaderSubFactorsList().length; h++) {
                var ApplicableRATIds = HmViewModel.HeaderSubFactorsList()[h].ApplicableRATId().split(',');
                ApplicableRATIds.sort();
                var ApplicableRATIdString = "";
                for (var i = 0; i < ApplicableRATIds.length; i++) {
                    if (i === 0)
                        ApplicableRATIdString += ApplicableRATIds[i].toString().trim();
                    else
                        ApplicableRATIdString += ',' + ApplicableRATIds[i].toString().trim();
                }
                if ((selectedassessmentsString.toString() === ApplicableRATIdString.toString() ||
                    ApplicableRATIdString.toString().includes(selectedassessmentsString.toString())) &&
                    data.RiskSubfactorId() != HmViewModel.HeaderSubFactorsList()[h].HeaderSubFactorId()) {
                    MappedHeaderList.push(HmViewModel.HeaderSubFactorsList()[h]);
                }
            }

            HmViewModel.HeaderSubFactorsDropDownList(MappedHeaderList);
            HmViewModel.HeaderSubFactorsDropDownList.valueHasMutated();
            data.HeaderUID(TempHeaderUID);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ApplicabilityRelHeaderEvent() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    //Function to bind the applicability Dropdown Dynamically starts here
    function GetAllAssessmentTypes() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAssessmentTypesByCategory",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "ZATId": HmViewModel.ZATRATList()[0].ZAT_UID() }
            })
                .success(function (jsonResult, error) {
                    var AssessmentIdArray = [];
                    HmViewModel.AssessmentTypeList([]);
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                        var MappedAssessmentList = $.map(jsonResult, function (result) {
                            AssessmentIdArray.push(result.AssessmentId);
                            return new AssessmentListModel(result);
                        });
                        HmViewModel.AssessmentTypeList(MappedAssessmentList);
                        InitiateAreaLevelTree(AssessmentIdArray.join());
                    }
                    else {
                        if (jsonResult.length == 0 || jsonResult == null) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);

                        }
                        else {
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                        }
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in RiskAreasfactors.js';
            logger.logMessage(msg);
        }
    }
    //Function to bind the applicability Dropdown ends here
    function jsTreeModel(item) {
        var self = this;

        self.id = item.AreaLevelId.toString();
        self.text = item.AreaLevelName;
        if (HmViewModel.AreaLeveljstree()[self.id].length > 0) {
            self.nodes = $.map(HmViewModel.AreaLeveljstree()[self.id], function (result) {
                return new jsTreeModel(result);
            });
        }
        self.state = { expanded: false };
        self.dead_node = item.DeadNode;
        self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
    }

    //Function to bind the survey categories Dropdown Dynamically starts here
    function GetAllSurveyCategories() {
        try {
            var headers = appsecurity.getSecurityHeaders();
          return   $.ajax({
                url: "/api/Configuration/GetAllSurveyCategories",
                type: "GET",
                headers: headers
            })
              .success(function (jsonResult, error) {
                  if (jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                      HmViewModel.ZATRATListLength(jsonResult.length);
                      HmViewModel.ZATRATList([]);
                      for (var i = 0; i < jsonResult.length; i++) {

                          if (jsonResult[i].SurveyGroupShortName == 'QTDR') {


                              var splitID = $.map(jsonResult[i].AssessmentTypeId.split(","), $.trim);
                              for (var j = 0; j < splitID.length; j++) {
                                  HmViewModel.ZATRATList().push(new ZATRATModel(jsonResult[i].SurveyCategoryId, jsonResult[i].SurveyCategoryName, splitID[j]));
                              }
                              break;
                          }


                      }
                      HmViewModel.ZATRATListDup(HmViewModel.ZATRATList());
                  }

                  else {
                      if (jsonResult.length > 0) {
                          var msg = 'Some error occured while deleting the assessment type. Please contact your Administrator.';
                          logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(ViewModel), true);
                      }
                      else {
                          logger.logError('Some error occured while deleting the assessment type. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                      }
                  }
                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteAssessmentType() method in RisksAreasfactors.js';
            logger.logMessage(msg);
        }

    }
    //Function to bind the survey categories Dropdown ends here


    //Average type radio button click
    function Avgtyperdbchanged(data, event) {
        try {
            //Toggle the weighted average flag
            document.getElementById(event.currentTarget.id).checked = true;
            if (event.currentTarget.value == "SimpleAverage") {
                HmViewModel.WeightedAverageType(false);
            }
            else {
                HmViewModel.WeightedAverageType(true);
            }
            return true;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function QuestionTypeChangedSubFactor(data, event) {
        try {

            HmViewModel.SubfactorQuestionType("H");
            //$('#appSubfactor').hide();
            HmViewModel.SelectedAssessmentTypeSubFactor([]);
            $('#EdiFactorAssessment').hide();
            $('#SubFactorAppTypeID').multiselect();
            BindDynamicHtmlForDropDowns();
            ApplicabilityRelHeaderEvent(data, event);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuestionTypeChangedSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function resetRadioButtons(data, event) {
        try {
            HmViewModel.HeaderSubFactorType("off");
            HmViewModel.SubfactorQuestionType(null);
            HmViewModel.SelectedAssessmentTypeSubFactor([]);
            $('#EdiFactorAssessment').hide();
            $('#SubFactorAppTypeID').multiselect();
            $('#SubFactorAppTypeID').multiselect('refresh');
            BindDynamicHtmlForDropDowns();
            ApplicabilityRelHeaderEvent(data, event);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: resetRadioButtons() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function LanguageAdded() {
        try {
            var selectedLanguage = HmViewModel.SelectedLanguageType();
            $('#DynamicRiskAreaNameDiv').empty();
            var RiskAreaNameHTMl = "";

            $('#DynamicCommentsDiv').empty();
            var CommentsHTMl = "";

            for (var j = 0; j < HmViewModel.SelectedLanguageType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {

                        RiskAreaNameHTMl += '<div class="form-group">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Risk Area Name (' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ') </label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<input id="riskareaname' + HmViewModel.SelectedLanguageType()[j] + '" class="form-control" placeholder="Risk Area Name in ' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: RiskAreaSubList().RiskAreaName" type="text" />' +
                            '</div>' +
                            '</div>';

                        CommentsHTMl += '<div class="form-group">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Comments (' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                            '<div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">' +
                            '<textarea id="EditRaTextArea' + HmViewModel.SelectedLanguageType()[j] + '" class="form-control" rows="5" placeholder="Risk Area Notes in ' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value:RiskAreaSubList().RiskAreaNotes" name="Notes" ></textarea>' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            if (RiskAreaNameHTMl != "" && CommentsHTMl != "") {
                $("#frmAreaRiskScroll").css({ "height": "auto", "max-height": "50rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                $("modalContent").css({ "height": "auto", "max-height": "65rem" });
            }
            //else
            //    $('#frmAreaRiskScroll').removeAttr("style");

            document.getElementById('DynamicRiskAreaNameDiv').innerHTML = RiskAreaNameHTMl;
            ko.cleanNode(document.getElementById('DynamicRiskAreaNameDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicRiskAreaNameDiv"));

            document.getElementById('DynamicCommentsDiv').innerHTML = CommentsHTMl;
            ko.cleanNode(document.getElementById('DynamicCommentsDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicCommentsDiv"));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LanguageAdded() method in RiskAreasFactor.js';
            logger.logMessage(msg);
        }
    }

    function GetConfigurationFreezeStatusByScreen() {
        try {
            $.ajax({
                url: "/api/Configuration/GetConfigurationFreezeStatusByScreen",
                type: "GET",
                data: { "CurrentScreenName": HmViewModel.CurrentScreenName() },
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from GetConfigurationFreezeStatusByScreen() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (appsecurity.WriteAccess())
                        jsonResult ? HmViewModel.ControlsAccess(false) : HmViewModel.ControlsAccess(true);
                }
                else
                    logger.logError('An error occurred while freezing Configurations. Please contact your Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetConfigurationFreezeStatusByScreen() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetConfigurationFreezeStatusByScreen() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetConfigurationFreezeStatusByScreen() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }

    function FreezeConfigurationsByScreen() {
        try {
            app.showMessage('Are you sure you want to freeze the Configurations? Once frozen, settings cannot be updated.', 'Freeze Configuration Settings', ['Freeze', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-plus text-default' })
                .then(function (option) {
                    if (option === 'Freeze') {
                        SetConfigurationFreezeByScreen();
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: FreezeConfigurationsByScreen() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function SetConfigurationFreezeByScreen() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SetConfigurationFreezeByScreen",
                headers: headers,
                type: "POST",
                data: { Status: 1, CurrentScreenName: HmViewModel.CurrentScreenName() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from SetConfigurationFreezeByScreen() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "1") {

                    HmViewModel.ControlsAccess(false);

                    logger.logSuccess('Configurations are frozen successfully.', 'Success', system.getModuleId(HmViewModel), true);
                    location.reload(true);
                }
                else if (jsonResult == "0") {
                    HmViewModel.ControlsAccess(true);
                    logger.logError('An error occurred while freezing Configurations. Please contact your Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    

                }
                else {
                    if (jsonResult.startsWith('INC')) {
                        var msg = 'An error occurred while freezing Configurations. Please contact your Administrator.';
                        logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred while freezing Configurations. Please contact your Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }

                     }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from SetConfigurationFreezeByScreen() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetConfigurationFreezeByScreen() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from SetConfigurationFreezeByScreen() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }

    //To disable the transactions checkbox - survey launch flag
    function GetAllSurveyType(GetAllSurveyTypeAjax) {
        try {
            $.ajax(GetAllSurveyTypeAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllSurveyType() in RisksAreasfactors.js';
            logger.logMessage(msg);

        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedSurvey = $.map(jsonResult, function (result) {
                        var SurveyModelObj = new SurveyModel(result);
                        addNewDivTab(SurveyModelObj);
                        return SurveyModelObj;
                    });
                    HmViewModel.SurveyDetailsList(mappedSurvey);
                    for (i = 0; i < HmViewModel.SurveyDetailsList().length; i++)
                        if (HmViewModel.SurveyDetailsList()[i].surveyType() == "QTDR") {
                            if (HmViewModel.SurveyDetailsList()[i].SurveyStatus()) {
                                $('#responseapplicability3').attr('disabled', true);
                            }
                            else {
                                $('#responseapplicability3').attr('disabled', false);
                            }
                        }

                }
                else
                    logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllSurveyType() in RisksAreasfactors.js';
                logger.logMessage(msg);

            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllSurveyType() method in RisksAreasfactors.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllSurveyType() method in RisksAreasfactors.js';
                logger.logMessage(msg);
            }
        }
    }

    //subfactor cancel button
    function cancelRsfButton() {
        try {

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: cancelRsfButton() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //subfactor popup save button
    function saveRsfButton(data) {
        try {
            for (var i = 0, j = HmViewModel.RiskSubFactorsList().length; i < j; i++) {
                if (data.RiskSubfactorId() == HmViewModel.RiskSubFactorsList()[i].RiskSubfactorId())
                    data.TargetRow(i);
            }
            var newRsfObservable = new RiskSubFactorModel({
                RiskFactorId: data.RiskFactorId(), RiskSubfactorMatchId: data.RiskSubfactorMatchId(), RiskSubfactorId: data.RiskSubfactorId(), RiskSubfactorName: data.RiskSubfactorName(),
                AssessmentType: data.AssessmentType(), AssessmentTypeId: data.AssessmentTypeId(), RULE_ID: data.RuleId(),
                RULE_CATEGORY_CODE: data.RuleCategoryCode(), RULE_SUBCATEGORY_CODE: data.RuleSubCategoryCode(),
                CalculationApplicabilityFlag: data.CalculationApplicabilityFlag()
            });
            newRsfObservable.TargetRow(data.TargetRow());
            HmViewModel.editableRiskSubFactor(newRsfObservable);

            $('#valErrorSubfactor').hide();
           // $('#loadingImgforQuanEdit').show();
            var ruleID = $('#ruleId').val();
            var RuleCategoryCode = $('#ruleCategoryCode').val();
            var RuleSubCategoryCode = $('#ruleSubCategoryCode').val();
                        
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/UpdateRiskSubFactorQuan",
                    type: "POST",
                    data: {
                        RiskSubfactorMatchId: data.RiskSubfactorMatchId(), RiskSubFactorId: data.RiskSubfactorId(), RiskSubFactorName: data.RiskSubfactorName(),
                        AssessmentType: data.AssessmentType(), AssessmentTypeId: data.AssessmentTypeId(), RULE_ID: data.RuleId(),
                        RULE_CATEGORY_CODE: data.RuleCategoryCode(), RULE_SUBCATEGORY_CODE: data.RuleSubCategoryCode()
                    },
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveRsfButton() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {

                    if (jsonResult.startsWith('INC') || jsonResult == "0")
                    {
                        //$('#loadingImgforQuanEdit').hide();
                        if (!jsonResult.startsWith('INC')) {
                            logger.logError('An error occurred. please try again.', 'Error', system.getModuleId(HmViewModel), true);
                        }
                        else {
                            var msg = 'An error occurred.please try again or Please contact your Administrator.';
                            logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                        }
                    }
                    else
                    {
                       // $('#loadingImgforQuanEdit').hide();
                        logger.logSuccess('Risk Sub-Factor updated successfully.', 'Success', system.getModuleId(HmViewModel), true);
                        var dataArr = ["", data.RiskFactorId(), ""]
                        format(dataArr);

                        $('#frmSubFactor').modal('hide');
                    }
                };
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:Success in updateRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in updateRiskSubFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    //for updating risk sub factor
    function updateRiskSubFactor(data) {
        try {

            var editedData = data;
            var RiskLevel = "";
            var RiskMapping = "";
            var selectedassessmetId = "";
            $('#valErrorSubfactor').hide();
            var ATIds = [];
            if (HmViewModel.SelectedAssessmentTypeSubFactorEdit() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactorEdit().length; i++) {
                    ATIds.push(HmViewModel.SelectedAssessmentTypeSubFactorEdit()[i].toString().trim());
                }
            }
            if (HmViewModel.SelectedAssessmentTypeSubFactor() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                    ATIds.push(HmViewModel.SelectedAssessmentTypeSubFactor()[i].toString().trim());
                }
            }
            ATIds.sort();

            var ATIDString = "";
            var ATNameString = "";
            var ATArray = [];
            for (var j = 0; j < HmViewModel.AssessmentTypeList().length; j++) {
                var countVar = 0;
                for (var i = 0; i < ATIds.length; i++) {
                    if (HmViewModel.AssessmentTypeList()[j].AssessmentId() === ATIds[i]) {
                        countVar++;
                    }
                }
                if (countVar === 1)
                    ATArray.push(HmViewModel.AssessmentTypeList()[j]);
            }

            for (var l = 0; l < ATArray.length; l++) {
                if (l === 0) {
                    ATIDString += ATArray[l].AssessmentId();
                    ATNameString += ATArray[l].AssessmentDisplayName();
                }
                else {
                    ATIDString += "," + ATArray[l].AssessmentId();
                    ATNameString += ", " + ATArray[l].AssessmentDisplayName();

                }

            }
            for (var i = 0; i < ATArray.length; i++) {
                if (i == 0) {
                    if ($('#' + ATArray[i].AssessmentId()).val() === undefined || $('#' + ATArray[i].AssessmentId()).val() === 0) {
                        RiskLevel += ATArray[i].AssessmentDisplayName() + ":" + $('#' + ATArray[i].AssessmentId() + 'RiskLevel option:selected').text().replace(/[0-9]/g, "").replace(" -", "");
                        RiskMapping += ATArray[i].AssessmentId() + ', ' + RiskMapping + $('#' + ATArray[i].AssessmentId() + 'RiskLevel').val();
                        selectedassessmetId += $('#' + ATArray[i].AssessmentId() + 'RiskLevel').val() + ', ' + selectedassessmetId + ATArray[i].AssessmentId();
                    }
                    else {
                        RiskLevel += ATArray[i].AssessmentDisplayName() + ":" + $('#' + ATArray[i].AssessmentId() + ' option:selected').text().replace(/[0-9]/g, "").replace(" -", "");
                        RiskMapping += ATArray[i].AssessmentId() + ', ' + RiskMapping + $('#' + ATArray[i].AssessmentId()).val();
                        selectedassessmetId += $('#' + ATArray[i].AssessmentId()).val() + ', ' + selectedassessmetId + ATArray[i].AssessmentId();
                    }
                }
                else {
                    if ($('#' + ATArray[i].AssessmentId()).val() === undefined || $('#' + ATArray[i].AssessmentId()).val() === 0) {
                        RiskLevel += ", " + ATArray[i].AssessmentDisplayName() + ":" + $('#' + ATArray[i].AssessmentId() + 'RiskLevel option:selected').text().replace(/[0-9]/g, "").replace(" -", "");
                        RiskMapping += "|" + ATArray[i].AssessmentId() + ', ' + $('#' + ATArray[i].AssessmentId() + 'RiskLevel').val();
                        selectedassessmetId += "|" + $('#' + ATArray[i].AssessmentId() + 'RiskLevel').val() + ', ' + ATArray[i].AssessmentId();
                    }
                    else {
                        RiskLevel += ", " + ATArray[i].AssessmentDisplayName() + ":" + $('#' + ATArray[i].AssessmentId() + ' option:selected').text().replace(/[0-9]/g, "").replace(" -", "");
                        RiskMapping += "|" + ATArray[i].AssessmentId() + ', ' + $('#' + ATArray[i].AssessmentId()).val();
                        selectedassessmetId += "|" + $('#' + ATArray[i].AssessmentId()).val() + ', ' + ATArray[i].AssessmentId();
                    }
                }
            }

            if (selectedassessmetId == "" || selectedassessmetId == ',undefined') {
                selectedassessmetId = "";
                var assessmentTypeList = data.AssessmentType().split(',');
                for (var k = 0; k < assessmentTypeList.length; k++) {
                    for (var j = 0; j < HmViewModel.AssessmentTypeList().length; j++) {
                        if (HmViewModel.AssessmentTypeList()[j].AssessmentDisplayName() == assessmentTypeList[k]) {
                            if (k == 0) {
                                selectedassessmetId += HmViewModel.AssessmentTypeList()[j].AssessmentId();
                            }
                            else {
                                selectedassessmetId += "|" + HmViewModel.AssessmentTypeList()[j].AssessmentId();
                            }
                        }
                    }
                }
            }
            data.AssessmentTypeId(ATIDString);
            data.AssessmentType(ATNameString);
            data.RiskLevel(RiskLevel);
            if (data.QuestionType() === "H")
                data.RiskLevel("NA");
            data.RiskMapping(RiskMapping);
            if (data.RiskAreaSubList() != null && data.RiskAreaSubList().length > 0) {

                for (var i = 0; i < data.RiskAreaSubList().length; i++) {
                    data.RiskAreaSubList()[i].RiskAreaName = $('#subfactorname' + data.RiskAreaSubList()[i].LanguageType.toString()).val();
                    //validate language text boxes
                    if (data.RiskAreaSubList()[i].RiskAreaName == "") {
                        $('#valErrorSubfactor').show();
                        $('#valErrorSubfactor').text('Sub-Factor Name in ' + GetLanguageName(data.RiskAreaSubList()[i].LanguageType.toString()) + ' is required.');
                        return;
                    } else {
                        $('#valErrorSubfactor').text('');
                    }
                }
            }
            if ($('#valErrorSubfactor').text() == "") {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/UpdateRiskSubFactor",
                    type: "POST",
                    data: {
                        RiskFactorId: data.RiskFactorId(), RiskSubFactorId: data.RiskSubfactorId(), RiskSubFactorName: data.RiskSubfactorName(),
                        AssessmentType: selectedassessmetId, RiskAreaSubList: data.RiskAreaSubList(), RiskLevel: data.RiskLevel(),
                        RiskMapping: data.RiskMapping(), QuestionType: data.QuestionType(), HeaderUID: data.HeaderUID()
                    },
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in updateRiskSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult == "2") {
                        logger.logError(data.RiskSubfactorName() + 'already exists. Please try updating with a different Name.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult == "1") {

                        var rowIndex = data.TargetRow();
                        HmViewModel.RiskSubFactorsList()[rowIndex].RiskSubfactorId(data.RiskSubfactorId());
                        HmViewModel.RiskSubFactorsList()[rowIndex].RiskSubfactorName(data.RiskSubfactorName());
                        // RiskScoreDrpDwnList()[HmViewModel.valueAML()];
                        if (data.RiskLevel() == "") { data.RiskLevel("NA"); }
                        var node = RfSubFactorTableObj.row(rowIndex).data([data.RiskSubfactorId(), data.RiskMapping(), data.RiskSubfactorName(), data.AssessmentType(), data.RiskLevel(), data.QuestionTypeDescription(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button text-center" data-bind="click: $root.editRiskSubFactorFunctionality,css: { disabled: (!$root.ControlsAccess()) }"><i class="demo-icon icon-file_edit_special"></i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button text-center" data-bind="click: $root.deleteRiskSubFactorFunctionality, css: { disabled: (!$root.ControlsAccess()) }"><i class="demo-icon icon-bin_special"></i></a>']).draw(false);
                        //  RfSubFactorTableObj.draw(false);
                        ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: HmViewModel.editRiskSubFactorFunctionality }, data);
                        ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: HmViewModel.deleteRiskSubFactorFunctionality }, data);
                        for (var i = 0, j = HmViewModel.RiskSubFactorReorderList().length; i < j; i++) {
                            if (HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId() == data.RiskSubfactorId()) {
                                HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName(data.RiskSubfactorName());
                                HmViewModel.RiskSubFactorReorderListDup()[i].RiskSubfactorName(data.RiskSubfactorName());
                                break;
                            }
                        }
                        logger.logSuccess('Risk Sub-Factor updated successfully.', 'Success', system.getModuleId(HmViewModel), true);
                        var rows = $("#subfactor").dataTable().fnGetNodes();
                        var cells = [];
                        for (var i = 0; i < rows.length; i++) {
                            // Get HTML of 3rd column (for example)
                            var x = $(rows[i]).find("td:eq(3)").html();
                            var y = x.replace('|', '<br/>');
                            $(rows[i]).find("td:eq(3)").html(y);
                        }
                    }
                    else if (jsonResult == "0") {
                        logger.logError('Risk Sub-Factor already exists. Please try updating the Risk Sub-Factor with a different name.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult.startsWith('INC')) {
                        var msg = 'An error occurred. Please try again by refreshing the page.';
                        logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);

                    }
                    else {
                        logger.logError('An error occurred. Please try again by refreshing the page.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                };
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:Success in updateRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in updateRiskSubFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    //for adding risk sub factor
    function addRiskSubFactor(data) {
        try {
            var selectedassessmetId = "";
            var riskSubFactorObj = "";
            $('#valErrorSubfactor').hide();
            var QuestionType = HmViewModel.SubfactorQuestionType();

            for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                //To-do: need to update below code and remove hardcoded value
                if (i == 0)
                    selectedassessmetId += $('#' + HmViewModel.SelectedAssessmentTypeSubFactor()[i] + '.classdoesntexist').val() + ',' + selectedassessmetId + HmViewModel.SelectedAssessmentTypeSubFactor()[i];
                //selectedassessmetId += $('#' + HmViewModel.SelectedAssessmentTypeSubFactor()[i]).val() + ',' + selectedassessmetId + HmViewModel.SelectedAssessmentTypeSubFactor()[i];
                else
                    selectedassessmetId += "|" + $('#' + HmViewModel.SelectedAssessmentTypeSubFactor()[i] + '.classdoesntexist').val() + ',' + HmViewModel.SelectedAssessmentTypeSubFactor()[i];
            }
            HmViewModel.SubFactorAddAreaList([]);
            for (var j = 0; j < HmViewModel.SelectedLanguageSubFactorType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageSubFactorType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                        selectedItem = HmViewModel.SelectedLanguageSubFactorType()[j];
                        riskSubFactorObj = new RiskAreaSubFactor(selectedItem);
                        //validate language text boxes

                        if (riskSubFactorObj.RiskAreaName == "") {
                            $('#valErrorSubfactor').show();
                            $('#valErrorSubfactor').text('Sub-Factor Name in ' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' is required.');
                            return;
                        } else {
                            $('#valErrorSubfactor').text('');
                        }

                        HmViewModel.SubFactorAddAreaList.push(new RiskAreaSubFactor(selectedItem));
                    }
                }
            }
            if ($('#valErrorSubfactor').text() == "") {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/AddRiskSubFactor",

                    data: {
                        RiskFactorId: data.RiskFactorId(), RiskSubfactorId: data.RiskSubfactorId(), RiskSubfactorName: data.RiskSubfactorName(),
                        AssessmentType: selectedassessmetId, RiskAreaSubList: HmViewModel.SubFactorAddAreaList(), QuestionType: QuestionType,
                        HeaderUID: data.HeaderUID()
                    },
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in addRiskSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult.Incident_Description == null) {

                    if (jsonResult.flag == 1) {
                        GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);
                        //var newRiskSubfactor = new RiskSubFactorModel(jsonResult);
                        //HmViewModel.RiskSubFactorsList.push(newRiskSubfactor);
                        //var x = new RiskSubFactorSortModel(jsonResult);
                        //HmViewModel.RiskSubFactorSortOrder(HmViewModel.RiskSubFactorSortOrder() - 1);
                        //var y = new RiskSubFactorSortModel(jsonResult);
                        //HmViewModel.RiskSubFactorReorderList.push(x);
                        //HmViewModel.RiskSubFactorReorderListDup.push(y);
                        //RfSubFactorTableObj.draw(false);
                        //var node = RfSubFactorTableObj.row.add([newRiskSubfactor.RiskMapping(), newRiskSubfactor.RiskSubfactorName(), newRiskSubfactor.AssessmentType(), newRiskSubfactor.RiskLevel(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button text-center" data-bind="click: $root.editRiskSubFactorFunctionality"><i class="demo-icon icon-file_edit_special text-success">g</i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button text-center" data-bind="click: $root.deleteRiskSubFactorFunctionality"><i class="demo-icon icon-bin_special text-danger ">5</i></a>']).page('last').draw();
                        //RfSubFactorTableObj.page('last').draw(false);
                        ////var addedRow = $('#subfactor').find('tr').get(1);
                        //ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: HmViewModel.editRiskSubFactorFunctionality }, newRiskSubfactor);
                        //ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: HmViewModel.deleteRiskSubFactorFunctionality }, newRiskSubfactor);
                        logger.logSuccess('Risk Sub-Factor added successfully.', 'Success', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult.flag == null) {
                        logger.logError(data.RiskSubfactorName() + 'already exists. Please try adding a different Risk Sub-Factor.', 'Error', system.getModuleId(HmViewModel), true);

                    }
                }

                else {
                    if (jsonResult.Incident_Description != null) {
                        var msg = 'Failed to add Risk Sub-Factor.';
                        logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('Failed to add Risk Sub-Factor.', 'Error', system.getModuleId(HmViewModel), true);
                    }

                };
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addRiskSubFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in addRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    //add risk subfactor button
    function addRiskSubFactorFunctionality(data, event) {
        try {
            HmViewModel.HeaderSubFactorsDropDownList([]);
            HmViewModel.HeaderTypeSubFactor(true);
            HmViewModel.SubfactorQuestionType(null);
            HmViewModel.HeaderSubFactorType("off");
            HmViewModel.LanguageddFactorVisible(true);
            if (HmViewModel.ObjGeneralSettings.LanguageList().length == 0) {
                HmViewModel.ObjGeneralSettings.getLanguages();
            }
            HmViewModel.LanguageList = HmViewModel.ObjGeneralSettings.LanguageList();
            if (HmViewModel.LanguageList[0].LANGUAGE_ID._latestValue == 1) {
                HmViewModel.LanguageList.splice(0, 1);
            }
            HmViewModel.SelectedLanguageSubFactorType([]);
            HmViewModel.SelectedAssessmentTypeSubFactor([]);
            HmViewModel.SelectedAssessmentTypeSubFactorEdit([]);
            for (var s = 0; s < HmViewModel.RiskFactorList().length; s++) {
                if (parseInt(HmViewModel.RiskFactorList()[s].RiskFactorId()) == parseInt(HmViewModel.RiskFactorId())) {
                    HmViewModel.CurrentRiskFactorType(HmViewModel.RiskFactorList()[s].MappedAssessmentType())
                    break;
                }
            }

            var mappedassessment = $.map(HmViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < HmViewModel.CurrentRiskFactorType().length; i++) {
                    if (HmViewModel.CurrentRiskFactorType()[i].ID == parseInt(result.AssessmentId())) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }

            });
            HmViewModel.SubFactorAssessmentTypeList(mappedassessment);
            HmViewModel.AssessmentTypeSubFactor(HmViewModel.AssessmentTypeSubFactorParent());
            var RiskAreaSubFactorObj = [];
            RiskAreaSubFactorObj[0] = new RiskAreaSubFactor(-999);
            var newRiskSubFactor = new RiskSubFactorModel({
                RiskFactorId: HmViewModel.RiskFactorId(), RiskSubfactorId: 999, AMLRiskScore: "", SANCRiskScore: "",
                RiskSubfactorName: "", AssessmentType: HmViewModel.AssessmentTypeSubFactor(), RiskAreaSubList: RiskAreaSubFactorObj,
                HeaderUID: -999
            });
            HmViewModel.editableRiskSubFactor(newRiskSubFactor);
            //HmViewModel.valueAML(HmViewModel.RiskScoreDrpDwnList()[0].Id());
            //HmViewModel.valueSANC(HmViewModel.RiskScoreDrpDwnList()[0].Id());
            HmViewModel.rsfPopUpTitle("Add Risk Sub-Factor Details");
            //ko.applyBindingsToNode($('#frmSubFactor').find('button').get(1), { click: RiskFactorViewModal.saveRsfButton }, RiskFactorViewModal);
            ko.applyBindingsToNode($('#frmSubFactor').find('button').get(2), { click: HmViewModel.cancelRsfButton }, HmViewModel);
            HmViewModel.addPopUpCss(true);
            HmViewModel.editPopUpCss(false);
            HmViewModel.EditSubFactorVisible(false);
            $('#appSubfactor').show();
            $('#EdiFactorAssessment').hide();
            $('#SubFactorAppTypeID').multiselect();
            $('#RASubFactorLanguage').multiselect();
            $('#frmSubFactor').modal('show');

            isRsfEdit = false;
            setTimeout("$('#subfactorname').focus();", 200);

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addRiskSubFactorFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function RiskAreaSubFactor(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#subfactorname' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaSubFactor() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    };
    //editing risk sub factor
    function editRiskSubFactorFunctionality(data, event) {
        try {
            for (var i = 0, j = HmViewModel.RiskSubFactorsList().length; i < j; i++) {
                if (data.RiskSubfactorId() == HmViewModel.RiskSubFactorsList()[i].RiskSubfactorId())
                    data.TargetRow(i);
            }
            var newRsfObservable = new RiskSubFactorModel({
                RiskFactorId: data.RiskFactorId(), RiskSubfactorMatchId: data.RiskSubfactorMatchId(), RiskSubfactorId: data.RiskSubfactorId(), RiskSubfactorName: data.RiskSubfactorName(),
                AssessmentType: data.AssessmentType(), AssessmentTypeId: data.AssessmentTypeId(), RULE_ID: data.RuleId(),
                RULE_CATEGORY_CODE: data.RuleCategoryCode(), RULE_SUBCATEGORY_CODE: data.RuleSubCategoryCode()      
            });
            newRsfObservable.TargetRow(data.TargetRow());
            HmViewModel.editableRiskSubFactor(newRsfObservable);
                            
            HmViewModel.rsfPopUpTitle("Edit Risk Sub-Factor Details");
            ko.applyBindingsToNode($('#frmSubFactor').find('input').get(0), { value: HmViewModel.editableRiskSubFactor().RiskSubfactorName }, HmViewModel);
           
            //$('#ruleId').val(data.RuleId());
            //$('#ruleCategoryCode').val(data.RuleCategoryCode());
            //$('#ruleSubCategoryCode').val(data.RuleSubCategoryCode());
           
            HmViewModel.addPopUpCss(false);
            HmViewModel.editPopUpCss(true);        
            $('#frmSubFactor').modal('show');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:  editRiskSubFactorFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function LanguageSubFactorAdded() {
        try {
            var selectedLanguage = HmViewModel.SelectedLanguageSubFactorType();
            $('#DynamicSubFactorDiv').empty();
            var ResponseHTMl = "";

            for (var j = 0; j < HmViewModel.SelectedLanguageSubFactorType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageSubFactorType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {


                        ResponseHTMl += '<div class="form-group">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Sub-Factor Name (' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ') </label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<input id="subfactorname' + HmViewModel.SelectedLanguageSubFactorType()[j] + '" class="form-control" placeholder="Risk Sub-Factor Name in ' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: SubFactorRiskAreaList().RiskSubfactorName" type="text" />' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            document.getElementById('DynamicSubFactorDiv').innerHTML = ResponseHTMl;
            ko.cleanNode(document.getElementById('DynamicSubFactorDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicSubFactorDiv"));

            if (selectedLanguage.length > 2 || HmViewModel.SelectedAssessmentTypeSubFactor().length > 2) {
                $("#frmSubFactorScroll").css({ "height": "auto", "max-height": "50rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                $("modalContent").css({ "height": "auto", "max-height": "65rem" });
            }
            //else {
            //    $("#frmSubFactorScroll").removeAttr("Style");
            //}
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LanguageSubFactorAdded() method in  RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function AddDynamicSubFactorElements(item) {
        try {
            $('#DynamicSubFactorDiv').empty();
            var ResponseHTMl = "";

            $.each(item, function (key, value) {
                ResponseHTMl += '<div class="form-group">' +
                    '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Sub-Factor Name (' + GetLanguageName(value.LanguageType) + ')</label>' +
                    '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                    '<input id="subfactorname' + value.LanguageType + '" class="form-control" data-bind="value: SubFactorRiskAreaList().RiskSubfactorName" type="text" />' +
                    '</div>' +
                    '</div>';
            });

            document.getElementById('DynamicSubFactorDiv').innerHTML = ResponseHTMl;
            ko.cleanNode(document.getElementById('DynamicSubFactorDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicSubFactorDiv"));

            if (item.length > 2) {
                $("#frmSubFactorScroll").css({ "height": "29rem", "overflow-y": "scroll", "overflow-x": "hidden" });
            }
            //else {
            //    $('#frmSubFactorScroll').removeAttr("style");
            //}
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddDynamicSubFactorElements() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtmlForDropDownsEdit(data) {
        try {
            var DynamicHTMl = "";
            var arr = [];
            for (var k = 0; k < data.length; k++) {
                var splitID = data[k].split(',')

                for (var g = 0; g < HmViewModel.AssessmentTypeList().length; g++) {
                    if (parseInt(splitID[0].toString().trim()) == HmViewModel.AssessmentTypeList()[g].AssessmentId()) {
                        DynamicHTMl += '<div class="form-group" id="appSubfactor_RiskLevel">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">' + HmViewModel.AssessmentTypeList()[g].AssessmentName() + ' Score</label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<select id="' + HmViewModel.AssessmentTypeList()[g].AssessmentId().replace(" ", "") + 'RiskLevel" data-bind="foreach:{data: InherentRiskLevelList, as: \'List1\'}" class="form-control">' +
                            '<!-- ko if: (List1.AssessmentTypeId ==' + splitID[0] + '|| List1.AssessmentTypeId == 99999)-->' +
                            '<!-- ko if: !(List1.isQuantitative ==0)-->' +
                            '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                            '<option data-bind="text: RiskLevelDescription,value:RiskLevelId"></option>' +
                            '</optgroup>' +
                            '<!--/ko -->' +
                            '<!--/ko -->' +
                            '</select>' +
                            //'<select id="' + HmViewModel.AssessmentTypeList()[g].AssessmentId() + '" data-bind="options: $root.RiskScoreDrpDwnList,optionsText :\'DisplayText\', optionsValue: \'Id\'" class="form-control"></select>' +
                            '</div>' +
                            '</div>';

                    }
                }

            }


            document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl
            ko.cleanNode(document.getElementById('DynamicScoreDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicScoreDiv"));
            for (var k = 0; k < data.length; k++) {
                var splitIDMap = data[k].split(',');
                if (splitIDMap[1] !== undefined)
                    $('#' + parseInt(splitIDMap[0].replace(" ", "")) + 'RiskLevel').val(parseInt(splitIDMap[1].replace(" ", "")));
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDownsEdit() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    //deleting subfactor button click
    function deleteRiskSubFactorFunctionality(data, event) {
        try {
            var selectedRow = $(event.currentTarget).closest("tr").get(0);
            data.TargetRow(selectedRow._DT_RowIndex);
            app.showMessage('Are you sure you want to delete this Risk Sub-Factor? Once deleted, it cannot be undone.', 'Delete Risk Sub-Factor', ['Confirm', 'Cancel'])
                .then(function (option) {
                    if (option === 'Confirm') {
                        deleteRiskSubFactor(data, event);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteRiskSubFactorFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //deleting risk subfactor
    function deleteRiskSubFactor(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteSubRiskFactor",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    RiskSubfactorId: data.RiskSubfactorId()
                }),
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call deleteRiskSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult == "1") {
                        var targetRow = $(event.currentTarget).closest("tr").get(0);
                        data.TargetRow(targetRow._DT_RowIndex);
                        RfSubFactorTableObj.row(targetRow).remove().draw(false);
                        HmViewModel.RiskSubFactorsList.splice(data.TargetRow(), 1);
                        GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);
                        //for (var i = 0; i < HmViewModel.RiskSubFactorReorderList().length; i++) {
                        //    if (data.RiskSubfactorId() == HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId()) {
                        //        HmViewModel.RiskSubFactorReorderList.remove(HmViewModel.RiskSubFactorReorderList()[i]);
                        //        break;
                        //    }
                        //}
                        //HmViewModel.RiskSubFactorSortOrder(HmViewModel.RiskSubFactorSortOrder()-1)
                        //for (var i = 0; i < HmViewModel.RiskSubFactorReorderListDup().length; i++) {
                        //    if (data.RiskSubfactorId() == HmViewModel.RiskSubFactorReorderListDup()[i].RiskSubfactorId()) {
                        //        HmViewModel.RiskSubFactorReorderListDup.remove(HmViewModel.RiskSubFactorReorderListDup()[i]);
                        //        break;
                        //    }
                        //}
                        //for (var i = 0; i < HmViewModel.RiskSubFactorReorderListDup().length; i++) {
                        //    HmViewModel.RiskSubFactorReorderListDup()[i].SortOrder(i + 1);
                        //    HmViewModel.RiskSubFactorReorderListDup()[i].SortOrder(i + 1);
                        //}
                        //for (var i = 0; i < HmViewModel.RiskSubFactorReorderListDup().length; i++) {
                        //    HmViewModel.RiskSubFactorReorderListDup()[i].SortOrder(i + 1);
                        //    HmViewModel.RiskSubFactorReorderListDup()[i].SortOrder(i + 1);
                        //}
                        logger.logSuccess('Risk Sub-Factor deleted successfully.', 'Success', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult == "0") {
                        logger.logError('Risk Sub-Factor does not exist or has already been deleted. Please try reloading the page and try again.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult.startsWith('INC')) {
                        var msg = 'An error occurred. Please try again by refreshing the page.';
                        logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);

                    }
                    else {
                        logger.logError('An error occurred. Please try again by refreshing the page.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                };
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteRiskSubFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    //deleting Risk Factor
    function deleteFunctionalityRF(data, event) {
        try {
            app.showMessage('Are you sure you want to delete this Risk Factor? Once deleted, it cannot be undone.', 'Delete Risk Factor', ['Confirm', 'Cancel'])
                .then(function (option) {
                    if (option === 'Confirm') {
                        deleteRiskFactor(data, event);
                    }
                });

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:deleteFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function deleteRiskFactor(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteRiskFactor",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    RiskFactorID: data.RiskFactorId()
                }),
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in deleteRiskFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(result, status) {
            try {
                if (result == 1) {
                    var targetRow = $(event.currentTarget).closest("tr").get(0);
                    data.TargetRow(targetRow._DT_RowIndex);
                    RfTableObj.row(targetRow).remove().draw(false);
                    HmViewModel.RiskFactorList.splice(data.TargetRow(), 1);
                    for (var i = 0; i < HmViewModel.RiskFactorReorderList().length; i++) {
                        if (data.RiskFactorId() == HmViewModel.RiskFactorReorderList()[i].RiskFactorId()) {
                            HmViewModel.RiskFactorReorderList.remove(HmViewModel.RiskFactorReorderList()[i]);
                            break;
                        }
                    }
                    HmViewModel.RiskFactorSortOrder(HmViewModel.RiskFactorSortOrder() - 1);
                    for (var i = 0; i < HmViewModel.RiskFactorReorderListDup().length; i++) {
                        if (data.RiskFactorId() == HmViewModel.RiskFactorReorderListDup()[i].RiskFactorId()) {
                            HmViewModel.RiskFactorReorderListDup.remove(HmViewModel.RiskFactorReorderListDup()[i]);
                            break;
                        }
                    }
                    for (var i = 0; i < HmViewModel.RiskFactorReorderList().length; i++) {
                        HmViewModel.RiskFactorReorderList()[i].SortOrder(i + 1);
                        HmViewModel.RiskFactorReorderList()[i].SortOrder(i + 1);
                    }
                    for (var i = 0; i < HmViewModel.RiskFactorReorderListDup().length; i++) {
                        HmViewModel.RiskFactorReorderListDup()[i].SortOrder(i + 1);
                        HmViewModel.RiskFactorReorderListDup()[i].SortOrder(i + 1);
                    }
                    //RiskFactorViewModal.RiskFactorList.remove(data);
                    logger.logSuccess('Risk Factor deleted successfully.', 'Success', system.getModuleId(HmViewModel), true);
                }
                else if (result == 0) {
                    logger.logWarning('No such Risk Factor exists. Please refresh the page and perform the delete operation.', 'Warning', system.getModuleId(HmViewModel), true);
                    //  app.showMessage("No Such Risk Factor Exists. Please Refresh the Page again and peform the Delete", "Error in Delete Operation", ["OK"]);
                }
                else {
                    logger.logError('An error occurred. Please refresh the page again and perform the delete operation.', 'Error', system.getModuleId(HmViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in deleteRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in deleteRiskFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

    }

    //editing Risk Factor
    function editFunctionalityRF(data, event) {
        try {
            HmViewModel.LanguageddFactorVisible(false);
            HmViewModel.EditFactorVisible(true);
            var Assessment = "";
            var AssessmentIds = [];
            for (var k = 0; k < HmViewModel.AssessmentTypeList().length; k++) {
                for (var f = 0; f < data.MappedAssessmentType().length; f++) {
                    if (parseInt(HmViewModel.AssessmentTypeList()[k].AssessmentId()) == data.MappedAssessmentType()[f].ID) {
                        if (k == 0)
                            Assessment = HmViewModel.AssessmentTypeList()[k].AssessmentName();
                        else {
                            if (Assessment == "") {
                                Assessment += HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                            else {
                                Assessment += ", " + HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                        }
                        AssessmentIds.push(HmViewModel.AssessmentTypeList()[k].AssessmentId());
                    }
                }
            }
            var selectedRow = $(event.currentTarget).closest("tr").get(0);
            data.TargetRow(selectedRow._DT_RowIndex);
            var newObservable = new RiskFactorModel({});
            newObservable.RiskFactorId(data.RiskFactorId());
            newObservable.RiskFactorName(data.RiskFactorName());
            newObservable.RiskAreaId(data.RiskAreaId());
            newObservable.AssessmentType(data.AssessmentType());
            newObservable.FactorRiskAreaList(data.FactorRiskAreaList());
            //Quan response code
            HmViewModel.editableRiskFactor(newObservable);
            HmViewModel.editableResponseTypes([]);
            HmViewModel.editableResponseTypesForFactor = ([]);
            HmViewModel.assessmentSelected(false);
            //GetQuanResponseColumnDetails();
            //selected lang list
            if (newObservable.FactorRiskAreaList().length < 1) {
                GetFactorQuanResponseAndLanguages(data.RiskFactorId());
                newObservable.FactorRiskAreaList = HmViewModel.FactorRiskAreaList;
            }
            else {
                HmViewModel.FactorRiskAreaList = newObservable.FactorRiskAreaList();
            }
            newObservable.TargetRow(selectedRow._DT_RowIndex);
            HmViewModel.AssessmentTypeFactor(data.AssessmentType());
            HmViewModel.AssessmentTypeFactorDisabled(true);
            //if (HmViewModel.AssessmentTypeFactor() == "BOTH")//condition to enable drop down when the Risk Area Type  is Both
            //    HmViewModel.AssessmentTypeFactorDisabled(false);
            //else
            //    HmViewModel.AssessmentTypeFactorDisabled(true);

            HmViewModel.popUpTitle("Edit Risk Factor Details");
            HmViewModel.addPopUpCss(false);
            HmViewModel.editPopUpCss(true);
            //Add dynamic language inputs
            if (HmViewModel.FactorRiskAreaList != null && HmViewModel.FactorRiskAreaList.length > 0) {
                AddDynamicFactorElements(HmViewModel.FactorRiskAreaList);

                $.each(HmViewModel.FactorRiskAreaList, function (key, value) {
                    $('#questionname' + value.LanguageType.toString()).val(value.RiskAreaName);
                });
            }
            if (HmViewModel.FactorRiskAreaList.length <= 0 && HmViewModel.editableResponseTypesForFactor.length <= 0) {
                $("#modalContent").removeAttr("style");
                $("#outerdiv").removeAttr("style");
            }
            if (HmViewModel.editableResponseTypesForFactor.length <= 0) { $("#outerdiv").removeAttr("style"); }
            $('#frmRiskFactor').modal('show');

            $('#RFApplicabilityDropdown').hide();
            $('#EditFactorAssessment').empty();
            document.getElementById('EditFactorAssessment').innerHTML = Assessment;
            $('#modalContentFactor').css({
                'margin-top': '30%'
            });

            var mappedassessment = $.map(HmViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < HmViewModel.CurrentRiskAreaType().length; i++) {
                    if (HmViewModel.CurrentRiskAreaType()[i].ID == parseInt(result.AssessmentId())) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }

            });
            HmViewModel.FactorAssessmentTypeList(mappedassessment);

            var ModifiedATList = [];
            HmViewModel.FactorAssessmentTypeListModified([]);
            for (var j = 0; j < HmViewModel.FactorAssessmentTypeList().length; j++) {
                var countVar = 0;
                for (var i = 0; i < data.MappedAssessmentType().length; i++) {
                    //if (HmViewModel.FactorAssessmentTypeList().indexOf(data.MappedAssessmentType()[i].ID) > 0) {
                    if (HmViewModel.FactorAssessmentTypeList()[j].AssessmentId() == data.MappedAssessmentType()[i].ID) {
                        countVar++;
                    }
                }
                if (countVar == 0)
                    ModifiedATList.push(HmViewModel.FactorAssessmentTypeList()[j]);
            }
            HmViewModel.FactorAssessmentTypeListModified(ModifiedATList);
            HmViewModel.SelectedAssessmentTypeFactor([]);
            HmViewModel.SelectedAssessmentTypeFactorEdit(AssessmentIds);
            if (HmViewModel.FactorAssessmentTypeListModified().length > 0) {
                $('#FactorAppTypeIDModified').multiselect();
                $('#FactorAppTypeIDModified').multiselect('refresh');
            }
            else
                $('#FactorAppTypeIDModified').hide();

            isEdit = true;
            setTimeout("$('#frmRiskFactor #factorname').focus();", 200);
            if (!HmViewModel.isGlobalFlag()) {
                GetFactorApplicabilityDetails(data.RiskFactorId()).then(function () {

                })
            }
            else {
                HmViewModel.assessmentSelected(false);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: editFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //PopUp for adding Riskfactor
    function ShowFactorPopUp(event, a, b) {
        try {
            GetQuanResponseColumnDetails();
            if (HmViewModel.ObjGeneralSettings.LanguageList().length == 0) {
                HmViewModel.ObjGeneralSettings.getLanguages();
            }
            HmViewModel.LanguageList = HmViewModel.ObjGeneralSettings.LanguageList();
            if (HmViewModel.LanguageList[0].LANGUAGE_ID._latestValue == 1) {
                HmViewModel.LanguageList.splice(0, 1);
            }
            HmViewModel.SelectedLanguageFactorType([]);
            HmViewModel.SelectedAssessmentTypeFactor([]);
            HmViewModel.LanguageddFactorVisible(true);
            HmViewModel.EditFactorVisible(false);
            var newRiskFactor = new RiskFactorModel({ RiskFactorId: 999, RiskFactorName: "", RiskAreaId: a.currentTarget.value, FactorRiskAreaList: new RiskAreaFactor(""), ZATIdList: "", ZATNames: "" });
            HmViewModel.editableRiskFactor(newRiskFactor);
            var mappedassessment = $.map(HmViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < HmViewModel.CurrentRiskAreaType().length; i++) {
                    if (HmViewModel.CurrentRiskAreaType()[i].ID == parseInt(result.AssessmentId())) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }

            });
            HmViewModel.FactorAssessmentTypeList(mappedassessment)
            $('#FactorAppTypeID').multiselect();
            HmViewModel.SelectedAssessmentTypeFactor([]);
            HmViewModel.assessmentSelected(false);
            HmViewModel.AssessmentTypeFactor(HmViewModel.CurrentRiskAreaType());
            HmViewModel.popUpTitle("Add Risk Factor Details");
            HmViewModel.addPopUpCss(true);
            $('#frmRiskFactor').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });
            isEdit = false;
            $('#RFApplicabilityDropdown').show();
            $('#RAFactorLanguage').multiselect();
            setTimeout("$('#frmRiskFactor #factorname').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ShowFactorPopUp() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function AvgtyperdbchangedFactor(data, event) {
        try {
            //Toggle the weighted average flag
            document.getElementById(event.currentTarget.id).checked = true;
            if (event.currentTarget.value == "SimpleAverageFactor") {
                HmViewModel.FactorWeightedAverageType(false);
            }
            else {
                HmViewModel.FactorWeightedAverageType(true);
            }
            return true;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    // ajax call for risk factor add
    function saveRiskFactorPopUpButton(data) {
        try {
            HmViewModel.AssessmentTypeFactor()
            // if (ValidateResponsesAtFactorLevel(data)) {
            $('#valErrorRF').hide();
            var duplicateCheck = 0;
            for (var i = 0, j = HmViewModel.RiskFactorList().length; i < j; i++) {
                if ((HmViewModel.editableRiskFactor().RiskFactorName().toUpperCase() == HmViewModel.RiskFactorList()[i].RiskFactorName().toUpperCase()) && (HmViewModel.editableRiskFactor().TargetRow() != i))
                    duplicateCheck++;
            }
            if (HmViewModel.editableRiskFactor().RiskFactorName() == "") {
                $('#valErrorRF').show();
                $('#valErrorRF').text('Risk Factor name is required.');
            }
            else if (HmViewModel.editableRiskFactor().RiskFactorName().length > 500) {
                $('#valErrorRF').show();
                $('#valErrorRF').text('Risk Factor name cannot exceed 500 characters. Please enter a valid Risk Factor.');
            }
            else {
                if (!isEdit) {
                    if (duplicateCheck == 1) {
                        $('#valErrorRF').show();
                        $('#valErrorRF').text(HmViewModel.editableRiskFactor().RiskFactorName() + ' already exists. Please enter a different Risk Factor.');
                    }
                    else {
                        addRiskFactor(data);
                        if ($('#valErrorRF').text() == "") {
                            $('#frmRiskFactor').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                    }
                }
                else {
                    if (duplicateCheck == 1) {
                        $('#valErrorRF').show();
                        $('#valErrorRF').text(HmViewModel.editableRiskFactor().RiskFactorName() + ' already exists. Please enter a different Risk Factor.');
                    }
                    else {
                        update(data);
                        if ($('#valErrorRF').text() == "") {
                            $('#frmRiskFactor').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                    }
                }
            }

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveRiskFactorPopUpButton() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

    }

    function ApplicabilityChanged() {
        try {
            if (!HmViewModel.isGlobalFlag()) {
                var selectedAssessmentType = HmViewModel.SelectedAssessmentTypeFactor();
                if (selectedAssessmentType.length > 0) {
                    HmViewModel.assessmentSelected(true);
                } else {
                    HmViewModel.assessmentSelected(false);
                }
                if (!HmViewModel.SimpleAverageType()) {
                    document.getElementById('WghtdAvgFactor').checked = true;
                }
                else {
                    document.getElementById('SmplAvgFactor').checked = true;
                }
                var AssessmentType = HmViewModel.FactorAssessmentTypeList();
                var responseTypeLenght = HmViewModel.editableResponseTypesForFactor.length;
                HmViewModel.AssessmentTypeColumnList([]);
                HmViewModel.editableResponseTypes([]);
                for (i = 0; i < selectedAssessmentType.length; i++) {
                    for (j = 0; j < AssessmentType.length; j++) {
                        if (selectedAssessmentType[i] == AssessmentType[j].AssessmentId()) {


                            for (k = 0; k < responseTypeLenght; k++) {

                                var responseType = HmViewModel.editableResponseTypes().length + 1;
                                HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                                    ResponseId: HmViewModel.editableResponseTypesForFactor[k].ResponseId(),
                                    ResponseType: "RESPONSE" + responseType,
                                    description: HmViewModel.editableResponseTypesForFactor[k].description(),
                                    calculationapplicability: HmViewModel.editableResponseTypesForFactor[k].calculationapplicability(),
                                    currencyapplicability: HmViewModel.editableResponseTypesForFactor[k].currencyapplicability(),
                                    weightings: HmViewModel.editableResponseTypesForFactor[k].weightings(),
                                    response: HmViewModel.editableResponseTypesForFactor[k].response(),
                                    Weightedaverageflag: HmViewModel.FactorWeightedAverageType(),
                                    SimpleAverageflag: HmViewModel.SimpleAverageType(),
                                    isGlobalFlag: HmViewModel.isGlobalFlag(),
                                    AssessmentType: AssessmentType[j].AssessmentName(),
                                    AssessmentTypeId: AssessmentType[j].AssessmentId()
                                }));

                                if (HmViewModel.editableResponseTypesForFactor[k].calculationapplicability() == false) {
                                    $("#RESPONSE" + responseType).attr('disabled', 'disabled');
                                }
                            }

                        }
                    }
                }
                if (!HmViewModel.SimpleAverageType()) {
                    HmViewModel.FactorWeightedAverageType(true);
                }
                else {
                    HmViewModel.FactorWeightedAverageType(false);
                }
            }
            else {
                var selectedAssessmentType = HmViewModel.SelectedAssessmentTypeFactor();
                var AssessmentType = HmViewModel.FactorAssessmentTypeList();
                var responseTypeLenght = HmViewModel.editableResponseTypesForFactor.length;
                HmViewModel.AssessmentTypeColumnList([]);
                HmViewModel.editableResponseTypes([]);
                for (i = 0; i < selectedAssessmentType.length; i++) {
                    for (j = 0; j < AssessmentType.length; j++) {
                        if (selectedAssessmentType[i] == AssessmentType[j].AssessmentId()) {


                            for (k = 0; k < responseTypeLenght; k++) {

                                var responseType = HmViewModel.editableResponseTypes().length + 1;
                                HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                                    ResponseId: HmViewModel.editableResponseTypesForFactor[k].ResponseId(),
                                    ResponseType: "RESPONSE" + responseType,
                                    description: HmViewModel.editableResponseTypesForFactor[k].description(),
                                    calculationapplicability: HmViewModel.editableResponseTypesForFactor[k].calculationapplicability(),
                                    currencyapplicability: HmViewModel.editableResponseTypesForFactor[k].currencyapplicability(),
                                    weightings: HmViewModel.editableResponseTypesForFactor[k].weightings(),
                                    response: HmViewModel.editableResponseTypesForFactor[k].response(),
                                    Weightedaverageflag: HmViewModel.FactorWeightedAverageType(),
                                    isGlobalFlag: HmViewModel.isGlobalFlag(),
                                    AssessmentType: AssessmentType[j].AssessmentName(),
                                    AssessmentTypeId: AssessmentType[j].AssessmentId()
                                }));

                                if (HmViewModel.editableResponseTypesForFactor[k].calculationapplicability() == false) {
                                    $("#RESPONSE" + responseType).attr('disabled', 'disabled');
                                }
                            }

                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ApplicabilityChanged() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function update(data) {
        try {
            var selectedAssessmentTypeFactor = [];
            for (var i = 0; i < HmViewModel.SelectedAssessmentTypeFactor().length; i++) {
                selectedAssessmentTypeFactor.push(HmViewModel.SelectedAssessmentTypeFactor()[i]);
            }
            for (var i = 0; i < HmViewModel.SelectedAssessmentTypeFactorEdit().length; i++) {
                selectedAssessmentTypeFactor.push(HmViewModel.SelectedAssessmentTypeFactorEdit()[i]);
            }
            HmViewModel.SelectedAssessmentTypeFactor([]);
            HmViewModel.SelectedAssessmentTypeFactor(selectedAssessmentTypeFactor);
            HmViewModel.SelectedZATRATList([]);
            var MappedZATRATList = [];
            for (var j = 0; j < HmViewModel.SelectedAssessmentTypeFactor().length; j++) {
                for (var k = 0; k < HmViewModel.ZATRATList().length; k++) {
                    if (HmViewModel.ZATRATList()[k].ZAT_UID() === HmViewModel.InherentSetupQuantObj().SurveyCategoryId() &&
                        HmViewModel.ZATRATList()[k].RAT_UID() === HmViewModel.SelectedAssessmentTypeFactor()[j].toString()) {
                        MappedZATRATList.push(new ZATRATModel(HmViewModel.InherentSetupQuantObj().SurveyCategoryId(), null, HmViewModel.SelectedAssessmentTypeFactor()[j]));
                    }
                }
            }

            HmViewModel.SelectedZATRATList(MappedZATRATList);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            var responseData = $.map(HmViewModel.editableResponseTypes(), function (item) {
                return {
                    ResponseId: item.ResponseId(),
                    Rank: item.Rank(),
                    ResponseType: item.ResponseType(),
                    description: item.description(),
                    calculationapplicability: item.calculationapplicability() == 1 ? true : false,
                    currencyapplicability: item.currencyapplicability(),
                    weightings: item.weightings(),
                    response: item.response(),
                    Weightedaverageflag: HmViewModel.FactorWeightedAverageType(),
                    isGlobalFlag: HmViewModel.isGlobalFlag(),
                    AssessmentType: item.AssessmentType(),
                    AssessmentTypeId: item.AssessmentTypeId()
                };
            });
            HmViewModel.UpdateRiskAreaLangList([]);
            var riskFactorEditObj = "";
            $('#valErrorRF').hide();

            $.each(HmViewModel.FactorRiskAreaList, function (key, value) {
                riskFactorEditObj = new RiskAreaFactor(value.LanguageType);
                if (riskFactorEditObj.RiskAreaName == "") {
                    $('#valErrorRF').show();
                    $('#valErrorRF').text('Risk Factor name in ' + GetLanguageName(value.LanguageType) + ' is required.');
                    return;
                } else {
                    $('#valErrorRF').text('');
                }

                HmViewModel.UpdateRiskAreaLangList.push(riskFactorEditObj);
            });
            if ($('#valErrorRF').text() == "") {
                UpdateRiskFactorAjax = {
                    url: "/api/Configuration/UpdateRiskFactor",
                    type: "POST",
                    data: {
                        RiskFactorId: HmViewModel.editableRiskFactor().RiskFactorId(),
                        RiskFactorName: HmViewModel.editableRiskFactor().RiskFactorName(),
                        RiskAreaId: HmViewModel.editableRiskFactor().RiskAreaId(),
                        RiskAreaName: HmViewModel.editableRiskFactor().RiskAreaName(),
                        AssessmentType: HmViewModel.editableRiskFactor().AssessmentType(),
                        QuantitativeResponseColumns: responseData,
                        RiskAreaSubList: HmViewModel.UpdateRiskAreaLangList(),
                        ZATRATModelObj: HmViewModel.SelectedZATRATList()
                    },
                    headers: headers
                };
                $.ajax(UpdateRiskFactorAjax)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in update() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(result, status) {
            try {
                if (result == "2") {
                    logger.logError(data.RiskFactorName() + 'already exists. Please try updating with a different name.', 'Error', system.getModuleId(HmViewModel), true);
                }
                else if (result == "1") {
                    GetRiskFactors(HmViewModel.CurrentRiskAreaId());
                    //var rowIndex = data.TargetRow();
                    //HmViewModel.RiskFactorList()[rowIndex].RiskFactorId(data.RiskFactorId());

                    //for (var i = 0; i < HmViewModel.RiskFactorList().length; i++) {
                    //    if (HmViewModel.RiskFactorList()[i].RiskFactorId() == data.RiskFactorId()) {
                    //        HmViewModel.AMLNumbering(HmViewModel.RiskFactorList()[i].AMLNumbering());
                    //        HmViewModel.SANCNumbering(HmViewModel.RiskFactorList()[i].SANCNumbering());
                    //        break;
                    //    }
                    //}
                    //HmViewModel.RiskFactorList()[rowIndex].RiskFactorName(data.RiskFactorName());
                    //var node = RfTableObj.row(rowIndex).data(['<div style="display:none"></div>', data.RiskFactorId(), data.RiskFactorName(), data.AssessmentType(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button text-center" data-bind="click: $root.editFunctionalityRF"><i class="demo-icon icon-file_edit_special text-success">g</i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button text-center" data-bind="click: $root.deleteFunctionalityRF"><i class="demo-icon icon-bin_special text-danger ">5</i></a>']).draw(false);
                    //ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: HmViewModel.editFunctionalityRF }, data);
                    //ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: HmViewModel.deleteFunctionalityRF }, data);
                    //ko.applyBindingsToNode($(node.node()).find('td').get(0), {}, HmViewModel);
                    //for (var i = 0, j = HmViewModel.RiskFactorReorderList().length; i < j; i++) {
                    //    if (HmViewModel.RiskFactorReorderList()[i].RiskFactorId() == data.RiskFactorId()) {
                    //        HmViewModel.RiskFactorReorderList()[i].RiskFactorName(data.RiskFactorName());
                    //        HmViewModel.RiskFactorReorderListDup()[i].RiskFactorName(data.RiskFactorName());
                    //        break;
                    //    }
                    //}
                    logger.logSuccess('Risk Factor updated successfully.', 'Success', system.getModuleId(HmViewModel), true);
                }
                else if (result == "0") {
                    logger.logWarning('No such Risk Factor exists. Please refresh the page and perform the edit operation.', 'Warning', system.getModuleId(HmViewModel), true);
                }
                else if (result.startsWith('INC')) {
                    var msg = 'An error occurred. Please refresh the page and perform the edit operation.';
                    logger.logError(result + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);

                }
                else {
                    logger.logError('An error occurred. Please refresh the page and perform the edit operation.', 'Error', system.getModuleId(HmViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in update() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }


        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in update() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in update() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }


    function GetFactorApplicabilityDetails(FactorId) {
        try {
            return $.ajax({
                url: "/api/Configuration/GetAllFactorApplicabilityDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { FactorID: FactorId }
            })
                .success(function (jsonResult, error) {
                    // var responseTypeLenght = HmViewModel.editableResponseTypesForFactor.length;
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                        HmViewModel.WeightedAverageType(true);
                        var MappedListDetails = $.map(jsonResult, function (result) {
                            if (result.Is_Average_Flag == 1) {
                                HmViewModel.WeightedAverageType(false);
                            }
                            return new QuanResponseColumnDetails(result);
                        });
                        HmViewModel.editableResponseTypes([]);
                        HmViewModel.editableResponseTypes(MappedListDetails);
                    }
                    else {
                        if (jsonResult.length > 0) {
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                        }
                    }
                    HmViewModel.assessmentSelected(true);
                    var element = $('#outerdiv')[0];
                    ko.cleanNode(element);
                    ko.applyBindings(HmViewModel, document.getElementById('outerdiv'));

                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetActiveRoles() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:GetFactorApplicabilityDetails() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function addRiskFactor(data) {
        try {
            var selectedassessmetId = "";
            var riskFactorObj = "";
            for (var i = 0; i < HmViewModel.SelectedAssessmentTypeFactor().length; i++) {
                if (i == 0)
                    selectedassessmetId += selectedassessmetId + HmViewModel.SelectedAssessmentTypeFactor()[i];
                else
                    selectedassessmetId += "|" + HmViewModel.SelectedAssessmentTypeFactor()[i];
            }
            $('#valErrorRF').hide();
            for (var j = 0; j < HmViewModel.SelectedLanguageFactorType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageFactorType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                        selectedItem = HmViewModel.SelectedLanguageFactorType()[j];
                        riskFactorObj = new RiskAreaFactor(selectedItem);
                        //validate language text boxes
                        if (riskFactorObj.RiskAreaName == "") {
                            $('#valErrorRF').show();
                            $('#valErrorRF').text('Risk Factor name in ' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' is required.');
                            return;
                        } else {
                            $('#valErrorRF').text('');
                        }
                        HmViewModel.ObjFactorRiskAreaList.push(riskFactorObj);
                    }
                }
            }
            HmViewModel.SelectedZATRATList([]);
            var MappedZATRATList = [];
            for (var j = 0; j < HmViewModel.SelectedAssessmentTypeFactor().length; j++) {
                for (var k = 0; k < HmViewModel.ZATRATList().length; k++) {
                    if (HmViewModel.ZATRATList()[k].ZAT_UID() === HmViewModel.InherentSetupQuantObj().SurveyCategoryId() &&
                        HmViewModel.ZATRATList()[k].RAT_UID() === HmViewModel.SelectedAssessmentTypeFactor()[j]) {
                        MappedZATRATList.push(new ZATRATModel(HmViewModel.InherentSetupQuantObj().SurveyCategoryId(), null, HmViewModel.SelectedAssessmentTypeFactor()[j]));
                    }
                }
            }

            HmViewModel.SelectedZATRATList(MappedZATRATList);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            var responseData = $.map(HmViewModel.editableResponseTypes(), function (item) {
                return {
                    ResponseId: item.ResponseId(),
                    Rank: item.Rank(),
                    ResponseType: item.ResponseType(),
                    description: item.description(),
                    calculationapplicability: item.calculationapplicability(),
                    weightings: item.weightings(),
                    response: item.response(),
                    Weightedaverageflag: HmViewModel.FactorWeightedAverageType(),
                    isGlobalFlag: HmViewModel.isGlobalFlag(),
                    AssessmentType: item.AssessmentType(),
                    AssessmentTypeId: item.AssessmentTypeId(),
                    currencyapplicability: item.currencyapplicability()
                };
            });

            headers.__RequestVerificationToken = csrfToken;
            AddRiskFactorAjax = {
                url: "/api/Configuration/AddRiskFactor",
                type: "POST",
                data: {
                    RiskFactorId: HmViewModel.editableRiskFactor().RiskFactorId(),
                    RiskFactorName: HmViewModel.editableRiskFactor().RiskFactorName(),
                    RiskAreaId: HmViewModel.editableRiskFactor().RiskAreaId(),
                    RiskAreaName: HmViewModel.editableRiskFactor().RiskAreaName(),
                    AssessmentType: selectedassessmetId,
                    QuantitativeResponseColumns: responseData,
                    RiskAreaSubList: HmViewModel.ObjFactorRiskAreaList._latestValue,
                    ZATRATModelObj: HmViewModel.SelectedZATRATList()
                },
                headers: headers
            }
            $.ajax(AddRiskFactorAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in addRiskFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                HmViewModel.ObjFactorRiskAreaList([]);
                if (jsonResult.Incident_Description == null) {
                    if (jsonResult.RiskFactorId != 0 && jsonResult.RiskFactorNameClean != null) {
                        if (jsonResult.Flag == 1)
                            logger.logSuccess('Risk Factor added successfully.', 'Success', system.getModuleId(HmViewModel), true);
                        var newRiskFactor = new RiskFactorModel(jsonResult);
                        HmViewModel.RiskFactorList.push(newRiskFactor);
                        var newSortorderelement = new RiskFactorSortModel(jsonResult);
                        HmViewModel.RiskFactorSortOrder(HmViewModel.RiskFactorSortOrder() - 1);
                        var newSortorderelementDup = new RiskFactorSortModel(jsonResult);
                        HmViewModel.RiskFactorReorderList.push(newSortorderelement);
                        HmViewModel.RiskFactorReorderListDup.push(newSortorderelementDup);
                        var node = RfTableObj.row.add(['<div style="display:none"></div>', newRiskFactor.RiskFactorId(), newRiskFactor.RiskFactorName(), newRiskFactor.AssessmentType(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button text-center" data-bind="click: $root.editFunctionality"><i class="demo-icon icon-file_edit_special"></i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button text-center" data-bind="click: $root.deleteFunctionality"><i class="demo-icon icon-bin_special"></i></a>']).draw();
                        var addedRow = $('#tblRiskFactor').find('tr').get(1);
                        ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: HmViewModel.editFunctionalityRF }, newRiskFactor);
                        ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: HmViewModel.deleteFunctionalityRF }, newRiskFactor);
                        ko.applyBindingsToNode($(node.node()).find('td').get(0), { click: HmViewModel.trclick }, HmViewModel);

                    }
                    else {
                        logger.logError('Failed to add Risk Factor.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
                else if (jsonResult.RiskFactorId == null) {
                    logger.logError(data.RiskFactorName() + 'already exists. Please enter a different Risk Factor.', 'Error', system.getModuleId(HmViewModel), true);

                }
                else {
                       if (jsonResult == null) {
                             logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                       }
                        else {
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                        }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in addRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
            $('#frmRiskFactor').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        };

        function ajaxFail(error, status) {
            try {
                HmViewModel.ObjFactorRiskAreaList([]);
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"])
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in addRiskFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in addRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    function LanguageFactorAdded() {
        try {
            var selectedLanguage = HmViewModel.SelectedLanguageFactorType();
            $('#DynamicRiskFactorDiv').empty();
            var QuestionNameHTMl = "";

            for (var j = 0; j < HmViewModel.SelectedLanguageFactorType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageFactorType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {


                        QuestionNameHTMl += '<div class="form-group">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="margin-left: -15px !important;">Risk Factor Name (' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ') </label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" style="margin-left: 15px !important;">' +
                            '<input id="questionname' + HmViewModel.SelectedLanguageFactorType()[j] + '" class="form-control" placeholder="Risk Factor Name in ' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: FactorRiskAreaList().RiskFactorName" type="text" />' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            document.getElementById('DynamicRiskFactorDiv').innerHTML = QuestionNameHTMl;
            ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
            //ko.applyBindings(HmViewModel, document.getElementById("DynamicRiskFactorDiv"));
            if (selectedLanguage.length > 2) {
                $('#DynamicRiskFactorDiv').css({
                    "margin-left": ".7rem", "margin-bottom": "1rem",
                    "overflow-y": "scroll", "overflow-x": "hidden", "height": "auto", "max-height": "30rem",
                    "border": "1px solid lightgray",
                    "padding-top": "5px !important",
                    "padding-bottom": "5px !important",
                    "padding-top": "1rem"
                });
                $("modalContentSubFactor").css({ "height": "auto", "max-height": "75rem" });

            } else {
                $('#DynamicRiskFactorDiv').removeAttr("Style");
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LanguageFactorAdded() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function AddDynamicFactorElements(item) {
        try {
            $('#DynamicRiskFactorDiv').empty();
            var QuestionNameHTMl = "";

            if (item.length > 2) {
                $('#DynamicRiskFactorDiv').css({
                    "margin-left": ".7rem", "margin-bottom": "1rem",
                    "overflow-y": "scroll", "overflow-x": "hidden", "height": "11rem",
                    "border": "1px solid lightgray",
                    "padding-top": "5px !important",
                    "padding-bottom": "5px !important",
                    "padding-top": "1rem"
                });
            } else {
                $('#DynamicRiskFactorDiv').removeAttr("Style");
            }

            $.each(item, function (key, value) {
                QuestionNameHTMl += '<div class="form-group">' +
                    '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3"  style="margin-left: -15px !important;">Risk Factor Name (' + GetLanguageName(value.LanguageType) + ')</label>' +
                    '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"  style="margin-left: 15px !important;">' +
                    '<input id="questionname' + value.LanguageType + '" class="form-control" data-bind="value: FactorRiskAreaList().RiskAreaName" type="text" />' +
                    '</div>' +
                    '</div>';
            });

            document.getElementById('DynamicRiskFactorDiv').innerHTML = QuestionNameHTMl;
            ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicRiskFactorDiv"));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddDynamicFactorElements() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function RiskAreaFactor(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#questionname' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };


    function GetFactorQuanResponseAndLanguages(RiskFactorId) {
        try {
            GetRiskFactorLanListAjax = {
                url: "/api/Configuration/GetFactorQuanAndLanguageList",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                async: false,
                data: { "RiskFactorId": RiskFactorId }
            };
            GetRiskFactorLangList(GetRiskFactorLanListAjax);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetFactorQuanResponseAndLanguages() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function GetRiskFactorLangList(GetRiskFactorLanListAjax) {
        try {
            $.ajax(GetRiskFactorLanListAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetRiskFactorSubList() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.Incident_Description == null) {
                    if (jsonResult.RiskAreaSubList != 'undefined' && jsonResult.RiskAreaSubList != null) {
                        HmViewModel.FactorRiskAreaList = jsonResult.RiskAreaSubList;
                    }
                    if (jsonResult.QuantitativeResponseColumnsList != 'undefined' && jsonResult.QuantitativeResponseColumnsList != null) {
                        var mappedresponseColumnList = $.map(jsonResult.QuantitativeResponseColumnsList, function (result) {
                            return new QuantitativeResponseColumnsModel(result);
                        });
                        HmViewModel.editableResponseTypes(mappedresponseColumnList);
                        HmViewModel.editableResponseTypesForFactor = (mappedresponseColumnList);
                        HmViewModel.WeightedAverageType(HmViewModel.editableResponseTypes()[0].Weightedaverageflag());
                        HmViewModel.isGlobalFlag(HmViewModel.editableResponseTypes()[0].isGlobalFlag());

                        if (HmViewModel.EditFactorVisible()) {
                            if (HmViewModel.editableResponseTypesForFactor.length > 0) {
                                HmViewModel.assessmentSelected(true);
                                $("#ApplicabilityForFactor").attr('disabled', 'disabled')
                                HmViewModel.editableResponseTypes([]);

                                if (HmViewModel.editableResponseTypesForFactor[0].Weightedaverageflag()) {
                                    HmViewModel.FactorWeightedAverageType(true);
                                    document.getElementById("WghtdAvgFactor").checked = true;
                                } else {
                                    HmViewModel.FactorWeightedAverageType(false);
                                    document.getElementById("WghtdAvgFactor").checked = false;
                                    document.getElementById("SmplAvgFactor").checked = true;
                                }
                                for (k = 0; k < HmViewModel.editableResponseTypesForFactor.length; k++) {

                                    var responseType = HmViewModel.editableResponseTypes().length + 1;
                                    HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                                        ResponseId: HmViewModel.editableResponseTypesForFactor[k].ResponseId(),
                                        ResponseType: HmViewModel.editableResponseTypesForFactor[k].ResponseType(),
                                        description: HmViewModel.editableResponseTypesForFactor[k].description(),
                                        calculationapplicability: HmViewModel.editableResponseTypesForFactor[k].calculationapplicability(),
                                        currencyapplicability: HmViewModel.editableResponseTypesForFactor[k].currencyapplicability(),
                                        weightings: HmViewModel.editableResponseTypesForFactor[k].weightings(),
                                        response: HmViewModel.editableResponseTypesForFactor[k].ResponseType(),
                                        Weightedaverageflag: HmViewModel.editableResponseTypesForFactor[k].Weightedaverageflag(),
                                        isGlobalFlag: HmViewModel.editableResponseTypesForFactor[k].isGlobalFlag(),
                                        AssessmentType: HmViewModel.editableResponseTypesForFactor[k].AssessmentType(),
                                        AssessmentTypeId: HmViewModel.editableResponseTypesForFactor[k].AssessmentTypeId()
                                    }));
                                }

                            }
                        }
                    }
                }
                else {
                    if (jsonResult == null) {
                        HmViewModel.FactorRiskAreaList([]);
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);}
                    else {
                        HmViewModel.FactorRiskAreaList([]);
                        var msg = 'An error occurred. Please contact your Application Administrator.';
                        logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetRiskFactorSubList() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskFactorSubList() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskFactorSubList() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }
    }
    // for deleting the risk area alert
    function deleteRiskAreafunction(event, a) {
        try {

            var ID = a.currentTarget.id;
            app.showMessage('Are you sure you want to delete this Risk Area? Once deleted, it cannot be undone.', 'Delete Risk Area', ['Confirm', 'Cancel'])
                .then(function (option) {
                    if (option === 'Confirm') {
                        deleteRiskArea(ID);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteRiskAreafunction() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    // Deleting the risk area ajax call
    function deleteRiskArea(ID) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteRiskArea?SurveyCategoryId=" + HmViewModel.InherentSetupQuantObj().SurveyCategoryId(),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    RiskAreaId: ID
                }),
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in deleteRiskArea() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(result, status) {
            try {
                if (result == "1") {
                    GetAllRiskAreas();
                    //$("#" + ID).remove();
                    //for (var i = 0; i < HmViewModel.RiskAreaList().length; i++) {
                    //    if (HmViewModel.RiskAreaList()[i].RiskAreaId() == ID) {
                    //        HmViewModel.RiskAreaList.splice(i, 1);
                    //    }
                    //}
                    //$('#adddivtabdiv').tabs({ active: 0 });
                    //$($('#adddivtabdiv li').get(0)).trigger('click');
                    logger.logSuccess('Risk Area deleted successfully.', 'Success', system.getModuleId(HmViewModel), true);
                }
                else {
                    if (result.startsWith('INC')) {
                        var msg = 'Failed to delete Risk Area, Please contact your Application Administrator.';
                        logger.logError(result + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('Failed to delete Risk Area', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteRiskArea() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please log in again to complete the Operation.", "Error in Edit Operation", ["OK"])
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in deleteRiskArea() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteRiskArea() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }


    //tblriskfactor expand collapse method
    function trclick(data, event) {
        try {
            var tr = $(event.currentTarget).closest('tr');
            var row = RfTableObj.row(tr);
            checkExpandedRow(row, false);
            if (row.child.isShown()) {
                //close the open row
                row.child.hide();
                tr.removeClass('shown');
            }
            else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
                ko.applyBindingsToNode($('#subfactor').find('tbody').get(0), { foreach: HmViewModel.RiskSubFactorsList }, HmViewModel);
                //if (HmViewModel.ControlsAccess())
                   // ko.applyBindingsToNode($('#btnsfReorder'), { disabled: true, click: HmViewModel.OpenRiskSubFactorOrderPopup }, HmViewModel);
                //ko.applyBindingsToNode($('#addSubFactorBtn'), { click: HmViewModel.addRiskSubFactorFunctionality }, data);
                RfSubFactorTableObj = $("#subfactor").DataTable({
                    stateSave: true,
                    "bResponsive": true,
                    "bPaginate": true,
                    "order": [],
                    "aaSorting": [],

                    "aoColumnDefs": [{
                        "aTargets": [0],
                        "order": [],
                        "bVisible": false
                    }, {
                        "aTargets": [1],
                        "order": [],
                        "bSortable": false
                    },
                    {
                        "aTargets": [2],
                        "order": [],
                        "bSortable": false

                    },
                    {
                        "aTargets": [3],
                        "order": [],
                        "bSortable": false

                    },
                    {
                        "aTargets": [6],
                        "order": [],
                        "bSortable": false,
                        "sClass": "text-center",
                        "bVisible": HmViewModel.ControlsAccess()
                    }]
                })
                var rows = $("#subfactor").dataTable().fnGetNodes();
                var cells = [];
                for (var i = 0; i < rows.length; i++) {
                    // Get HTML of 3rd column (for example)
                    var x = $(rows[i]).find("td:eq(3)").html();
                    var y = x.replace('|', '<br/>');
                    $(rows[i]).find("td:eq(3)").html(y);
                }
                GetQuanHeadersByRiskFactor(row.data());
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: trclick() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function GetQuanHeadersByRiskFactor(data) {
        try {
            var FactorId = parseInt(data[1]);
            $.ajax({
                url: "/api/Configuration/GetQuanHeadersByRiskFactor",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "RiskFactorId": FactorId }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQuanHeadersByRiskFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, error) {
            try {
                HmViewModel.HeaderSubFactorsList([]);
                if (jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                    var mappedHeaders = $.map(jsonResult, function (result) {
                        return new RiskSubFactorHeaderModel(result);
                    });
                    HmViewModel.HeaderSubFactorsList(mappedHeaders);
                }
                else {
                    //code
                    if (jsonResult.length > 0) {
                        var msg = 'An error occurred. Please contact your Application Administrator.';
                        logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
     
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in  GetQuanHeadersByRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuanHeadersByRiskFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxfail in GetQuanHeadersByRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }

    function checkExpandedRow(row, isPaginating) {
        try {
            var currentRowIndex;
            var rowsInTable = $('#tblRiskFactor').find('tr');
            if (isPaginating)
                currentRowIndex = -1;
            else
                currentRowIndex = row.index();
            var info = RfTableObj.page.info();
            for (var i = 1, j = (rowsInTable.length); i < j; i++) {
                //if (currentRowIndex != (i - 1)) {
                var tr = $('#tblRiskFactor').find('tr').get(i);
                if (RfTableObj.row(tr).index() != row.index()) {
                    var tableRowIndex = (info.page * info.length) + (i - 1);

                    if ((RfTableObj.row(tableRowIndex).child() != undefined) && (RfTableObj.row(tableRowIndex).child.isShown())) {
                        RfTableObj.row(tableRowIndex).child.remove();
                        tr.removeAttribute('class', 'shown')
                        j = $('#tblRiskFactor').find('tr').length;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    // for adding tblsubfactor in the expanded row
    function format(data) {
        try {
            HmViewModel.RiskFactorId(data[1]);
            HmViewModel.AssessmentTypeSubFactorParent(data[5]);
            GetAllRiskSubFactorsAjax = {

                url: "/api/Configuration/GetRiskSubfactorForQuantConfig",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: {
                    "RiskFactorId": HmViewModel.RiskFactorId(),
                    "SurveyCategoryID": HmViewModel.ZATRATList()[0].ZAT_UID,
                    "AssessmentTypes": HmViewModel.ZATRATList()[0].RAT_UID
                },
                async: false
            };
            GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);

            var SfHtml = '<div class="child-active" style="margin-left:3em;">' +
                '<div class="panel panel-success panel-margin">' +
                '<div class="panel-heading">' +
                '<h5 class="panel-title riskFactorCellPanel">Sub-Factors';
            //if (HmViewModel.ControlsAccess()) {
            //    SfHtml += '<button id="addSubFactorBtn" class="btn btn-primary btn-xs pull-right addSubFactorBtn" data-bind="click: $root.addRiskSubFactorFunctionality" title="Click to add new Risk SubFactor">' +
            //        '<i class="fa fa-plus"></i> Add Sub-Factor' +
            //        '</button>';
            //}
            //if (HmViewModel.ControlsAccess()) {
            //    SfHtml += '<button style="margin-right:2em"  id="btnsfReorder" class="btn btn-primary btn-xs pull-right addSubFactorBtn" data-bind="click: $root.OpenRiskSubFactorOrderPopup" title="Click to re order the sequence of Risk Sub-Factor">' +
            //        '<i class="fa fa-sort"></i> Re-Order Risk Sub-Factors' +
            //        '</button>';
            //}


            SfHtml += '</h5>' +
                '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subfactor-margin">' +
                '<table id="subfactor" class="dataTable table-bordered" cellspacing="0">' +
                '<thead>' +
                '<tr>' +
                '<th style="display:none">Subfactor ID</th>' +
                '<th style="display:none">Risk Mapping</th>' +
                '<th>Sub-Factor Name</th>' +
                '<th>Rule ID</th>' +
                '<th style="text-align:left">Rule Category Code</th>' +
                '<th style="text-align:left">Rule SubCategory Code</th>' +

                '<th class="actions" style="text-align:center">Actions</th>' +
                '</tr>' +
                '</thead>' +
            '<tbody data-bind="foreach: RiskSubFactorsList">' +
                '<tr data-bind="css: { grayHeader: HeaderQuestionFlag() == true }">' +

                '<td style="display:none" data-bind="text: RiskSubfactorId"></td>' +
                '<td style="display:none" data-bind="text: RiskMapping"></td>' +

                '<td data-bind="text: RiskSubfactorName"></td>' +
                '<td data-bind="text: RuleId"></td>' +
                '<td data-bind="text: RuleCategoryCode" style="text-align:left"></td>' +
                '<td data-bind="text: RuleSubCategoryCode" style="text-align:left"></td>' +

                '<td class="text-center">' +
                '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button" data-bind="click: $root.editRiskSubFactorFunctionality, visible: HeaderQuestionFlag() == false">' +
                '<i class="demo-icon icon-file_edit_special"></i>' +
                '</a>' +
                '</td>' +

                '</tr>' +

                 '</tbody>' +
                '</table>' +
                '</div>';

            return SfHtml;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: format() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    // get all subfactor method
    function GetAllRiskSubFactors(GetAllRiskSubFactorsAjax) {
        try {

            $.ajax(GetAllRiskSubFactorsAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskSubFactors() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                HmViewModel.SelectedLanguageSubFactorType([]);
                HmViewModel.SubFactorRiskAreaList([]);

                HmViewModel.RiskSubFactorsList([]);
                HmViewModel.RiskSubFactorReorderList([]);
                HmViewModel.RiskSubFactorReorderListDup([]);

                var mappedRiskSubFactors = $.map(jsonResult, function (result) {
                    return new RiskSubFactorModel(result);
                });
                HmViewModel.RiskSubFactorSortOrder(0);
                var mappedRiskSubFactorssortorder = $.map(jsonResult, function (result) {
                    return new RiskSubFactorSortModel(result);
                });
                HmViewModel.RiskSubFactorSortOrder(0);
                var mappedRiskSubFactorssortorderDup = $.map(jsonResult, function (result) {
                    return new RiskSubFactorSortModel(result);
                });

                tableObj = $('#subfactor').DataTable();
                tableObj.destroy();
                $("#subfactor tbody tr").remove();
                HmViewModel.RiskSubFactorReorderList(mappedRiskSubFactorssortorder);
                HmViewModel.RiskSubFactorReorderListDup(mappedRiskSubFactorssortorderDup);
                HmViewModel.RiskSubFactorsList(mappedRiskSubFactors);
                RfSubFactorTableObj = $("#subfactor").DataTable({
                    "bResponsive": true,
                    "bPaginate": true,
                    "order": [],
                    "aaSorting": [],
                    stateSave: true,

                    "aoColumnDefs": [{
                        "aTargets": [0],
                        "order": [],
                        "bVisible": false
                    }, {
                        "aTargets": [1],
                        "order": [],
                        "bSortable": true
                    },
                    {
                        "aTargets": [2],
                        "order": [],
                        "bSortable": true
                    }, {
                        "aTargets": [3],
                        "order": [],
                        "bSortable": true,

                    },
                    {
                        "aTargets": [4],
                        "order": [],
                        "bSortable": false,
                        "sClass": "text-center",
                        "bVisible": (HmViewModel.ControlsAccess())
                        }]
                })
                //$('#subfactor').dataTable({
                //    /* Disable initial sort */
                //    "aaSorting": []
                //});

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskSubFactors() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in GetAllRiskSubFactors() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxfail in GetAllRiskSubFactors() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetAllInherentLevels() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllInherentLevelswithNA",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: 0, SurveyCategoryId: HmViewModel.InherentSetupQuantObj().SurveyCategoryId() }
            })
                .success(function (jsonResult, Error) {
                    if (jsonResult == 0 || jsonResult.length == 0 || jsonResult == null) {
                        document.getElementById("akshay").innerHTML = "Inherent Risk Levels are not yet configured for this profile of assessment."
                    }
                    else if (jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                        var mappedIRSData = $.map(jsonResult, function (result) {
                            return new RiskLevelModel(result);
                        });
                        var mappedIRSDataDup = $.map(jsonResult, function (result) {
                            return new RiskLevelModel(result);
                        });
                        HmViewModel.InherentRiskLevelListDup(mappedIRSDataDup);
                        HmViewModel.InherentRiskLevelList(mappedIRSData);
                    }
                    else {
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                })
                .fail(function (jsonResult, log) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllInherentLevels() method in RiskArea&Factor.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllInherentLevels() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function getIRSdata() {
        try {
            $.ajax({
                url: "/api/Configuration/GetIRSData",
                type: "GET",
                async: "false",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in  getIRSdata() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                    var mappedScore = $.map(jsonResult, function (result) {
                        if (result.DisplayText != "" && result.DisplayText != null) {
                            return new RiskScoreModel(result);
                        }

                    });
                    HmViewModel.RiskScoreDrpDwnList(mappedScore);
                    HmViewModel.valueAML(HmViewModel.RiskScoreDrpDwnList()[0].Id());
                    HmViewModel.valueSANC(HmViewModel.RiskScoreDrpDwnList()[0].Id());
                }
                else {
                    //app.showMessage('Please setup the Inherent Risk Levels before setting the Responses.', 'Inherent Risk Levels haven\'t be set up yet.', ['Ok'], false, {
                    //    buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
                    //})
                    //.then(function (option) {
                    //    if (option === 'Ok') {
                    //        router.navigate("#configuration/RiskLevel", true); // #configuration/RiskLevel
                    //    }
                    //});

                    if (jsonResult.length > 0) {
                        var msg = 'An error occurred. Please contact your Application Administrator.';
                        logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in  getIRSdata() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getIRSdata() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxfail in getIRSdata() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }

    function BulkUploadPopup(event, data) {
        try {
            for (var i = 0; i < HmViewModel.RiskAreaList().length; i++) {
                if (parseInt(HmViewModel.RiskAreaId()) == HmViewModel.RiskAreaList()[i].RiskAreaId()) {
                    HmViewModel.RiskAreaName(HmViewModel.RiskAreaList()[i].RiskAreaName());
                    break;
                }
            }
            HmViewModel.popUpTitle("Bulk Upload Quantitative Data");
            HmViewModel.addPopUpCss(true);
            $('#BulkUpload').modal('show');
            setTimeout("$('#BulkUpload').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BulkUploadPopup() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    function UploadExcelDocument(data, event) {
        try {
            var FileList = document.getElementById('FileUploader').files;
            if (FileList.length > 0) {
                var FileName = document.getElementById('FileUploader').files[0].name;
                if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM'
                ) {
                    if (FileList[0].size <= 3145728) {

                        document.getElementById('valfactorerror').innerHTML = "";

                        var FormDataObj = new FormData();
                        FormDataObj.append("File1", FileList[0]);
                        var request = new XMLHttpRequest();

                        request.onreadystatechange = function () {
                            if (request.readyState == 1) {
                                document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                $('#valfactorerror').show();
                            }
                            else if (request.readyState == 4) {
                                if (request.status == 200) {
                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                        if (request.responseText == "2") {
                                            document.getElementById('valfactorerror').innerHTML = "Error in file upload";
                                            logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(SurveyDashboardVM), true);
                                            $('#valfactorerror').show();
                                            var DocName = document.getElementById('FileUploader').files[0].name;
                                            document.getElementById('FileUploader').value = null;
                                            // SetComments(data.QuestionId(), "RD", "", DocName, JSON.parse(request.response), SrViewModel.UploadComment());
                                            $('#Exportexcel').modal('hide');
                                            $('body').removeClass('modal-open');
                                            $('.modal-backdrop').remove();
                                        }
                                        else if (request.responseText == "-1") {

                                            document.getElementById('valfactorerror').innerHTML = "Error in file upload";
                                            logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(HmViewModel), true);
                                            $('#valfactorerror').show();
                                            var DocName = document.getElementById('FileUploader').files[0].name;
                                            document.getElementById('FileUploader').value = null;
                                            // SetComments(data.QuestionId(), "RD", "", DocName, JSON.parse(request.response), SrViewModel.UploadComment());
                                            $('#BulkUpload').modal('hide');
                                            $('body').removeClass('modal-open');
                                            $('.modal-backdrop').remove();

                                        }
                                        else {
                                            document.getElementById('valfactorerror').innerHTML = "The file has been uploaded successfully.";
                                            logger.logSuccess('Uploaded Successfully ', 'Success', system.getModuleId(HmViewModel), true);
                                            $('#valfactorerror').show();
                                            var DocName = document.getElementById('FileUploader').files[0].name;
                                            document.getElementById('FileUploader').value = null;
                                            // SetComments(data.QuestionId(), "RD", "", DocName, JSON.parse(request.response), SrViewModel.UploadComment());
                                            $('#BulkUpload').modal('hide');
                                            $('body').removeClass('modal-open');
                                            $('.modal-backdrop').remove();
                                        }
                                    }
                                    else {


                                        document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                        logger.logError('Some Error Occured while Uploading Report.', 'Error', system.getModuleId(HmViewModel), true);
                                        $('#valfactorerror').show();
                                        document.getElementById('FileUploader').value = null;
                                        $('#BulkUpload').modal('hide');
                                        $('body').removeClass('modal-open');
                                        $('.modal-backdrop').remove();

                                    }
                                }
                                else
                                    ajaxFail(request, "");
                            }
                        };
                        request.upload.addEventListener('progress', function (event) {
                            document.getElementById('valfactorerror').innerHTML = "Uploading File...";

                        });
                        var RiskAreaName;
                        for (var i = 0; i < data.RiskAreaList().length; i++) {
                            if (parseInt(data.RiskAreaId()) == data.RiskAreaList()[i].RiskAreaId()) {
                                RiskAreaName = data.RiskAreaList()[i].RiskAreaName();
                                break;
                            }
                        }
                        request.withCredentials = true;
                        request.open('POST', "/api/Configuration/ImportExcelQuanBulkUplaod?RiskAreaId=" + parseInt(data.RiskAreaId()) + "&RiskAreaName=" + RiskAreaName);
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        request.setRequestHeader('Authorization', headers.Authorization);
                        request.setRequestHeader('RT', headers.RT);
                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                        request.send(FormDataObj);

                    }
                    else
                        document.getElementById('valfactorerror').innerHTML = "Upload File Size cannot exceed " + (HmViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.";
                }
                else
                    document.getElementById('valfactorerror').innerHTML = "Please Select Valid File to Upload";
            }

            else
                document.getElementById('valfactorerror').innerHTML = "Please Select a File to Upload";

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    router.navigate("configuration/RisksAreasfactors", true);

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadExcelDocument() method in RisksAreasfactors.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadExcelDocument() method in RisksAreasfactors.js';
                    logger.logMessage(msg);
                }
            };
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadExcelDocument() method in RisksAreasfactors.js';
            logger.logMessage(msg);
        }
    }

    function editRiskAreaFunction(event, data) {
        try {
            //$('#RaApplicabilityDropdown').hide();
            $('#RaLanguageDropdown').hide();
            HmViewModel.LanguageDropdownVisible(false);
            HmViewModel.EditAreaVisible(true);
            var Assessment = "";//HmViewModel.RiskAreaList
            for (var l = 0; l < HmViewModel.RiskAreaList().length; l++) {
                if (HmViewModel.RiskAreaList()[l].RiskAreaId() == HmViewModel.SelectedRiskAreaDetails().RiskAreaId()) {
                    HmViewModel.SelectedRiskAreaDetails().MappedAssessmentType(HmViewModel.RiskAreaList()[l].MappedAssessmentType());
                }
            }
            for (var k = 0; k < HmViewModel.AssessmentTypeList().length; k++) {

                for (var f = 0; f < HmViewModel.SelectedRiskAreaDetails().MappedAssessmentType().length; f++) {
                    if (parseInt(HmViewModel.AssessmentTypeList()[k].AssessmentId()) == HmViewModel.SelectedRiskAreaDetails().MappedAssessmentType()[f].ID) {
                        if (k == 0)
                            Assessment += HmViewModel.AssessmentTypeList()[k].AssessmentName();
                        else {
                            if (Assessment == "") {
                                Assessment += HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                            else {
                                Assessment += ", " + HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                        }
                    }
                }
            }

            var RiskAreaID = data.currentTarget.value;
            var newRiskArea = new RiskAreaModel({ RiskAreaId: HmViewModel.SelectedRiskAreaDetails().RiskAreaId(), RiskAreaName: HmViewModel.SelectedRiskAreaDetails().RiskAreaName(), RiskAreaType: HmViewModel.SelectedRiskAreaDetails().RiskAreaType(), RiskAreaNotes: HmViewModel.SelectedRiskAreaDetails().RiskAreaNotes(), RiskAreaSubList: HmViewModel.SelectedRiskAreaDetails().RiskAreaSubList() });
            HmViewModel.editableRiskArea(newRiskArea);
            if (HmViewModel.SelectedRiskAreaDetails().RiskAreaSubList() != null && HmViewModel.SelectedRiskAreaDetails().RiskAreaSubList().length > 0) {
                AddDynamicElements(HmViewModel.SelectedRiskAreaDetails().RiskAreaSubList());

                $.each(HmViewModel.SelectedRiskAreaDetails().RiskAreaSubList(), function (key, value) {
                    $('#riskareaname' + value.LanguageType.toString()).val(value.RiskAreaName);
                    $('#EditRaTextArea' + value.LanguageType.toString()).val(value.RiskAreaNotes);
                });
                $("#frmAreaRiskScroll").css({
                    "height": "34rem", "overflow-y": "scroll", "overflow-x": "hidden"
                });
            }
            //else {

            //    $("#frmAreaRiskScroll").removeAttr("style");
            //}
            HmViewModel.popUpTitle("Edit Risk Area Details");
            HmViewModel.AssessmentTypeAreaDisabled(true);
            HmViewModel.addPopUpCss(false);
            HmViewModel.editPopUpCss(true);
            $('#frmRiskArea').modal('show');
            $('#EditRaTextArea').attr('placeholder', 'Risk Area Notes');

            $('#EditAreaAssessment').empty();
            document.getElementById('EditAreaAssessment').innerHTML = Assessment;
            //$('#RaApplicabilityDropdown').hide();

            $('#EditAreaSurveyComponent').empty();
            document.getElementById('EditAreaSurveyComponent').innerHTML = HmViewModel.SelectedRiskAreaDetails().ZATNames();

            HmViewModel.AssessmentTypeListModified([]);
            HmViewModel.SelectedZATDropDownListEdit([]);
            HmViewModel.SelectedAssessmentType([]);
            HmViewModel.SelectedAssessmentTypeEdit([]);
            HmViewModel.ZATDropDownListModified([]);
            HmViewModel.SelectedZATDropDownList([]);

            var ModifiedATList = [];
            for (var i = 0; i < HmViewModel.AssessmentTypeList().length; i++) {
                var pushCount = 0;
                for (var j = 0; j < HmViewModel.SelectedRiskAreaDetails().MappedAssessmentType().length; j++) {
                    if (HmViewModel.AssessmentTypeList()[i].AssessmentId() !== ((HmViewModel.SelectedRiskAreaDetails().MappedAssessmentType()[j].ID).toString()))
                        pushCount++;
                }
                if (pushCount === HmViewModel.SelectedRiskAreaDetails().MappedAssessmentType().length)
                    ModifiedATList.push(HmViewModel.AssessmentTypeList()[i]);
                else
                    HmViewModel.SelectedAssessmentTypeEdit.push(HmViewModel.AssessmentTypeList()[i].AssessmentId());
            }

            HmViewModel.SelectedZATDropDownListEdit(HmViewModel.SelectedRiskAreaDetails().ZATIdList());


            if (ModifiedATList.length !== 0) {
                HmViewModel.AssessmentTypeListModified(ModifiedATList);
                $('#RAApplicabilityModified').multiselect();
                $('#RAApplicabilityModified').multiselect('refresh');
            }
            else {
                $('#RAApplicabilityModified').remove();
            }

            RATActionChangedEdit(data, event);

            var ZATRATListTemp = [];
            for (var h = 0; h < HmViewModel.ZATRATList().length; h++) {
                for (var k = 0; k < HmViewModel.AssessmentTypeList().length; k++) {
                    if (HmViewModel.AssessmentTypeList()[k].AssessmentId() == HmViewModel.ZATRATList()[h].RAT_UID()) {
                        ZATRATListTemp.push(HmViewModel.ZATRATList()[h]);
                    }
                }
            }

            var distinctZATs = [...new Set(ZATRATListTemp.map(x => x.ZAT_UID()))];

            HmViewModel.ZATRATListLength(distinctZATs.length);


            if (HmViewModel.ZATRATListLength() <= HmViewModel.SelectedRiskAreaDetails().ZATIdList().length) {
                $('#ZATApplicabilityModified').remove();
            }
            isEdit = true;
            setTimeout("$('#frmRiskArea #riskareaname').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: editRiskAreaFunction() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function AddDynamicElements(item) {
        //var selectedLanguage = HmViewModel.SelectedLanguageType();
        $('#DynamicRiskAreaNameDiv').empty();
        var RiskAreaNameHTMl = "";

        $('#DynamicCommentsDiv').empty();
        var CommentsHTMl = "";

        $.each(item, function (key, value) {
            RiskAreaNameHTMl += '<div class="form-group">' +
                '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Risk Area Name (' + GetLanguageName(value.LanguageType) + ')</label>' +
                '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                '<input id="riskareaname' + value.LanguageType + '" class="form-control" data-bind="value: RiskAreaSubList().RiskAreaName" type="text" />' +
                '</div>' +
                '</div>';

            CommentsHTMl += '<div class="form-group">' +
                '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Comments (' + GetLanguageName(value.LanguageType) + ')</label>' +
                '<div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">' +
                '<textarea id="EditRaTextArea' + value.LanguageType + '" class="form-control" rows="5" data-bind="value:RiskAreaSubList().RiskAreaNotes" name="Notes" ></textarea>' +
                '</div>' +
                '</div>';
        });

        document.getElementById('DynamicRiskAreaNameDiv').innerHTML = RiskAreaNameHTMl;
        ko.cleanNode(document.getElementById('DynamicRiskAreaNameDiv'));
        ko.applyBindings(HmViewModel, document.getElementById("DynamicRiskAreaNameDiv"));

        document.getElementById('DynamicCommentsDiv').innerHTML = CommentsHTMl;
        ko.cleanNode(document.getElementById('DynamicCommentsDiv'));
        ko.applyBindings(HmViewModel, document.getElementById("DynamicCommentsDiv"));


    }

    function OpenRiskAreaOrderPopup() {
        try {
            HmViewModel.popUpTitle("Re-Order Risk Areas");
            HmViewModel.addPopUpCss(true);
            $('#frmRiskAreaReordermodel').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaOrderPopup() method in OpenRIskAreaOrderPopup.js';
            logger.logMessage(msg);
        }
    }

    function OpenConfigureResponseTypePopup() {
        try {
            // $('#loadingMainImgDiv').show();
            HmViewModel.EditFactorVisible(false);
            GetQuanResponseColumnDetails().then(function () {
                if (!HmViewModel.SimpleAverageType()) {
                    document.getElementById('WghtdAvg').checked = true;
                    HmViewModel.WeightedAverageType(true);
                }
                else {
                    document.getElementById('SmplAvg').checked = true;
                    HmViewModel.SimpleAverageType(true);
                }
                $('#frmResponseTypemodel').modal('show');
                $('#frmResponseTypemodel .modal-content').css({
                    'height': 'auto'
                });
                GetAllSurveyTypeAjax = {
                    url: "/api/Survey/GetSurveyTypes",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                };
                GetAllSurveyType(GetAllSurveyTypeAjax);
                //$('#loadingMainImgDiv').hide();
                HmViewModel.popUpTitle("Configure Response Type");
                HmViewModel.addPopUpCss(true);
            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaOrderPopup() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function GetQuanResponseColumnDetails() {

        try {
            return $.ajax({
                url: "/api/Configuration/GetQuanResponseColumnDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                    var mappedresponseColumnList = $.map(jsonResult, function (result) {
                        return new QuantitativeResponseColumnsModel(result);
                    });
                    HmViewModel.editableResponseTypes([]);
                    HmViewModel.editableResponseTypes(mappedresponseColumnList);
                    HmViewModel.editableResponseTypesForFactor = (mappedresponseColumnList);
                    HmViewModel.SimpleAverageType(HmViewModel.editableResponseTypes()[0].SimpleAverageflag());
                    HmViewModel.isGlobalFlag(HmViewModel.editableResponseTypes()[0].isGlobalFlag());

                    if (HmViewModel.EditFactorVisible()) {
                        if (HmViewModel.editableResponseTypesForFactor.length > 0) {
                            HmViewModel.assessmentSelected(true);
                            $("#ApplicabilityForFactor").attr('disabled', 'disabled')
                            HmViewModel.editableResponseTypes([]);

                            if (HmViewModel.editableResponseTypesForFactor[0].Weightedaverageflag()) {
                                HmViewModel.FactorWeightedAverageType(true);
                                document.getElementById("WghtdAvgFactor").checked = true;
                            }
                            for (k = 0; k < HmViewModel.editableResponseTypesForFactor.length; k++) {

                                var responseType = HmViewModel.editableResponseTypes().length + 1;
                                HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                                    ResponseId: HmViewModel.editableResponseTypesForFactor[k].ResponseId(),
                                    ResponseType: HmViewModel.editableResponseTypesForFactor[k].ResponseType(),
                                    description: HmViewModel.editableResponseTypesForFactor[k].description(),
                                    calculationapplicability: HmViewModel.editableResponseTypesForFactor[k].calculationapplicability(),
                                    currencyapplicability: HmViewModel.editableResponseTypesForFactor[k].currencyapplicability(),
                                    weightings: HmViewModel.editableResponseTypesForFactor[k].weightings(),
                                    response: HmViewModel.editableResponseTypesForFactor[k].response(),
                                    SimpleAverageflag: HmViewModel.editableResponseTypesForFactor[k].SimpleAverageflag(),
                                    isGlobalFlag: HmViewModel.editableResponseTypesForFactor[k].isGlobalFlag(),
                                    AssessmentType: "SANC",
                                    AssessmentTypeId: HmViewModel.editableResponseTypesForFactor[k].AssessmentTypeId()
                                }));
                            }

                        }
                    }
                }
                else {
                    if (jsonResult.length > 0) {
                        var msg = 'An error occurred. Please contact your Application Administrator.';
                        logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    //this calls on click over reorder in subfactor
    function OpenRiskSubFactorOrderPopup() {
        try {
            HmViewModel.popUpTitle("Re-Order");
            HmViewModel.addPopUpCss(true);
            $('#frmRiskSubFactorReordermodel').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskSubFactorOrderPopup() method in RiskAreas&Factors.js';
            logger.logMessage(msg);
        }
    }
    //this calls when you click over reorder in factor
    function OpenRiskFactorOrderPopup() {
        try {
            $('#valfactorerror').hide();
            $('#RiskFactorReorderTableDiv').show();
            $('#RiskFactorReorderTable').show();
            $('#SaveFactorSortButton').show();
            HmViewModel.popUpTitle("Re-Order");
            HmViewModel.addPopUpCss(true);
            $('#frmRiskFactorReordermodel').modal('show');
            if (HmViewModel.RiskFactorReorderList().length == 0) {
                $('#valfactorerror').show();
                $('#RiskFactorReorderTableDiv').hide();
                $('#RiskFactorReorderTable').hide();
                $('#SaveFactorSortButton').hide();
                document.getElementById('valfactorerror').innerHTML = "No data is available.";
            }
            $('#modalContent').css({
                'margin-top': '25%'
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaPopup() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function OpenRiskAreaPopup() {
        try {
            HmViewModel.EditAreaVisible(false);
            HmViewModel.LanguageDropdownVisible(true);
            $('#RaApplicabilityDropdown').show();
            HmViewModel.AssessmentTypeAreaDisabled(false);
            if (HmViewModel.ObjGeneralSettings.LanguageList().length == 0) {
                HmViewModel.ObjGeneralSettings.getLanguages();
            }
            HmViewModel.LanguageList = HmViewModel.ObjGeneralSettings.LanguageList();
            if (HmViewModel.LanguageList[0].LANGUAGE_ID._latestValue == 1) {
                HmViewModel.LanguageList.splice(0, 1);
            }
            HmViewModel.SelectedAssessmentType([]);
            HmViewModel.SelectedLanguageType([]);
            HmViewModel.SelectedZATDropDownList([]);
            var newRiskArea = new RiskAreaModel({ RiskAreaId: 999, RiskAreaName: "", RiskAreaType: "", RiskAreaNotes: "", RiskAreaSubList: new RiskArea({ RiskAreaName: "", RiskAreaNotes: "", LanguageType: "" }), ZATIdList: "", ZATNames: "" });
            HmViewModel.editableRiskArea(newRiskArea);
            HmViewModel.popUpTitle("Add Risk Area Details");
            HmViewModel.addPopUpCss(true);
            $('#frmRiskArea').modal('show');
            $('#EditRaTextArea').attr('placeholder', 'Risk Area Notes');
            $('#modalContent').css({
                'margin-top': 'auto'
            });
            // $('#riskareaname').blur();

            isEdit = false;
            $('#RAApplicability').multiselect();
            $('#RALanguage').multiselect();
            setTimeout("$('#frmRiskArea #riskareaname').focus();", 200);
            HmViewModel.ZATDropDownList([]);
            $("#ZATApplicability").multiselect();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaPopup() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    // for adding a new risk area tab
    function saveRiskAreaPopUp(data) {
        // duplicate check for risk area
        try {
            $('#valErrorRA').text('');
            $('#valErrorRA').hide();
            var duplicateCheck = 0;
            for (var i = 0, j = HmViewModel.RiskAreaList().length; i < j; i++) {
                if ((data.RiskAreaName().toUpperCase() == HmViewModel.RiskAreaList()[i].RiskAreaName().toUpperCase()) && (data.RiskAreaName().toUpperCase() != HmViewModel.SelectedRiskAreaDetails().RiskAreaName().toUpperCase()))
                    duplicateCheck++;
            }
            if (HmViewModel.SelectedAssessmentType().length == 0 && HmViewModel.SelectedAssessmentTypeEdit().length == 0) {
                $('#valErrorRA').show();
                $('#valErrorRA').text('Select atleast one Assessment type.');
            }
            else if (data.RiskAreaName() == "") {
                $('#valErrorRA').show();
                $('#valErrorRA').text('Risk Area name is required.');
            }
            else {
                if (!isEdit) {
                    if (duplicateCheck == 1) {
                        $('#valErrorRA').show();
                        $('#valErrorRA').text(data.RiskAreaName() + ' already exists. Please enter a different Risk Area.');
                    }
                    else {
                        addRiskArea(data);
                        if ($('#valErrorRA').text() == "") {
                            $('#frmRiskArea').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                    }
                }
                else if (data.RiskAreaName().length > 100) {
                    $('#valErrorRA').show();
                    $('#valErrorRA').text('Risk Area name cannot exceed 100 characters.');
                }
                else if (data.RiskAreaNotes().length > 5000) {
                    $('#valErrorRA').show();
                    $('#valErrorRA').text('Risk Area notes cannot exceed 5000 characters.');
                }
                else {
                    if (duplicateCheck == 1) {
                        $('#valErrorRA').show();
                        $('#valErrorRA').text(data.RiskAreaName() + ' already exists. Please enter a different Risk Area.');
                    }
                    else {
                        if (data.RiskAreaSubList() != null && data.RiskAreaSubList().length > 0) {

                            for (var i = 0; i < data.RiskAreaSubList().length; i++) {
                                data.RiskAreaSubList()[i].RiskAreaName = $('#riskareaname' + data.RiskAreaSubList()[i].LanguageType.toString()).val();
                                data.RiskAreaSubList()[i].RiskAreaNotes = $('#EditRaTextArea' + data.RiskAreaSubList()[i].LanguageType.toString()).val();

                                if (data.RiskAreaSubList()[i].RiskAreaName == "") {
                                    $('#valErrorRA').show();
                                    $('#valErrorRA').text('Risk Area name in ' + GetLanguageName(data.RiskAreaSubList()[i].LanguageType) + ' is required.');
                                    return;
                                } else {
                                    $('#valErrorRA').text('');
                                }

                            }
                        }

                        updateRiskArea(data);
                        if ($('#valErrorRA').text() == "") {
                            $('#frmRiskArea').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveRiskAreaPopUp() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function updateRiskArea(data) {
        try {
            var selectedassessmentsType = [];
            for (var i = 0; i < HmViewModel.SelectedAssessmentType().length; i++) {
                selectedassessmentsType.push(HmViewModel.SelectedAssessmentType()[i]);
            }
            for (var i = 0; i < HmViewModel.SelectedAssessmentTypeEdit().length; i++) {
                selectedassessmentsType.push(HmViewModel.SelectedAssessmentTypeEdit()[i]);
            }
            HmViewModel.SelectedAssessmentType([]);
            HmViewModel.SelectedAssessmentType(selectedassessmentsType);

            var selectedZAT = [];
            for (var i = 0; i < HmViewModel.SelectedZATDropDownList().length; i++) {
                selectedZAT.push(HmViewModel.SelectedZATDropDownList()[i]);
            }
            for (var i = 0; i < HmViewModel.SelectedZATDropDownListEdit().length; i++) {
                selectedZAT.push(HmViewModel.SelectedZATDropDownListEdit()[i]);
            }
            HmViewModel.SelectedZATDropDownList([]);
            HmViewModel.SelectedZATDropDownList(selectedZAT);

            var MappedZATRATList = [];
            for (var h = 0; h < HmViewModel.SelectedZATDropDownList().length; h++) {
                for (var j = 0; j < HmViewModel.SelectedAssessmentType().length; j++) {
                    for (var k = 0; k < HmViewModel.ZATRATList().length; k++) {
                        if (HmViewModel.ZATRATList()[k].ZAT_UID() === HmViewModel.SelectedZATDropDownList()[h] &&
                            HmViewModel.ZATRATList()[k].RAT_UID() === HmViewModel.SelectedAssessmentType()[j]) {
                            MappedZATRATList.push(new ZATRATModel(HmViewModel.SelectedZATDropDownList()[h], null, HmViewModel.SelectedAssessmentType()[j]));
                        }
                    }
                }
            }
            HmViewModel.SelectedZATRATList(MappedZATRATList);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/UpdateRiskArea",
                type: "POST",
                data: {
                    RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName(), RiskAreaNotes: data.RiskAreaNotes(),
                    RiskAreaType: data.RiskAreaType(), RiskAreaSubList: data.RiskAreaSubList(), ZATRATModelObj: HmViewModel.SelectedZATRATList(),
                    Parent_Flag: 0
                },
                headers: headers
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in updateRiskArea() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "2") {
                    logger.logError(data.RiskAreaName() + 'already exists. Please try updating with a different Name.', 'Error', system.getModuleId(HmViewModel), true);
                }
                else if (jsonResult == "1") {
                    HmViewModel.SelectedRiskAreaDetails(data);
                    for (var i = 0, j = HmViewModel.RiskAreaList().length; i < j; i++) {
                        if (HmViewModel.RiskAreaList()[i].RiskAreaId() == HmViewModel.SelectedRiskAreaDetails().RiskAreaId()) {
                            HmViewModel.RiskAreaList()[i].RiskAreaType(data.RiskAreaType());
                            HmViewModel.RiskAreaList()[i].RiskAreaName(data.RiskAreaName());
                            HmViewModel.RiskAreaList()[i].RiskAreaNotes(data.RiskAreaNotes());
                            HmViewModel.RiskAreaList()[i].RiskAreaSubList(HmViewModel.SelectedRiskAreaDetails().RiskAreaSubList());
                            $('#lblRiskAreaName').text(data.RiskAreaName());
                            /*if (data.RiskAreaType().toUpperCase() == "SANC" || data.RiskAreaType().toUpperCase() == "SANCTIONS")
                                $('#lblRiskAreaType').text("Sanctions");
                            else
                                $('#lblRiskAreaType').text(data.RiskAreaType());*/
                            $('#lblRiskAreaNotes').text(data.RiskAreaNotes());
                            document.getElementById(data.RiskAreaId()).firstChild.innerText = data.RiskAreaName();
                        }
                    }
                    for (var i = 0, j = HmViewModel.RiskAreaReorderList().length; i < j; i++) {
                        if (HmViewModel.RiskAreaReorderList()[i].RiskAreaId() == HmViewModel.SelectedRiskAreaDetails().RiskAreaId()) {
                            HmViewModel.RiskAreaReorderList()[i].RiskAreaName(data.RiskAreaName());
                            HmViewModel.RiskAreaReorderListDup()[i].RiskAreaName(data.RiskAreaName());
                            break;
                        }
                    }
                    GetAllRiskAreas();
                    logger.logSuccess('Risk Area updated successfully.', 'Success', system.getModuleId(HmViewModel), true);
                }
                else {
                    if (jsonResult.startsWith('INC')) {
                        var msg = 'Failed to update Risk Area. Please contact your Application Administrator.';
                        logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('Failed to update Risk Area.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in updateRiskArea() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in updateRiskArea() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateRiskArea() method in RiskArea&Factor&Factors.js';
                logger.logMessage(msg);
            }
        }
    }

    function RiskArea(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#riskareaname' + item).val();
            self.RiskAreaNotes = $('#EditRaTextArea' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskArea() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function addRiskArea(data) {
        try {

            var selectedassessmetId = "";
            var selectedItem = "";
            var objelement = "";
            var riskAreaObj = "";
            var MappedZATRATList = [];
            HmViewModel.SelectedZATRATList([]);
            HmViewModel.SelectedZATDropDownList().push(HmViewModel.InherentSetupQuantObj().SurveyCategoryId());
            for (var i = 0; i < HmViewModel.SelectedAssessmentType().length; i++) {
                if (i == 0)
                    selectedassessmetId += selectedassessmetId + HmViewModel.SelectedAssessmentType()[i];
                else
                    selectedassessmetId += "|" + HmViewModel.SelectedAssessmentType()[i];
            }
            var selectedLanguages = "";
            for (var i = 0; i < HmViewModel.SelectedLanguageType().length; i++) {
                if (i == 0)
                    selectedLanguages = HmViewModel.SelectedLanguageType()[i];
                else
                    selectedLanguages += "|" + HmViewModel.SelectedLanguageType()[i];
            }
            for (var h = 0; h < HmViewModel.SelectedZATDropDownList().length; h++) {
                for (var j = 0; j < HmViewModel.SelectedAssessmentType().length; j++) {
                    for (var k = 0; k < HmViewModel.ZATRATList().length; k++) {
                        if (HmViewModel.ZATRATList()[k].ZAT_UID() === HmViewModel.SelectedZATDropDownList()[h] &&
                            HmViewModel.ZATRATList()[k].RAT_UID() === HmViewModel.SelectedAssessmentType()[j]) {
                            MappedZATRATList.push(new ZATRATModel(HmViewModel.SelectedZATDropDownList()[h], null, HmViewModel.SelectedAssessmentType()[j]));
                        }
                    }
                }
            }
            HmViewModel.SelectedZATRATList(MappedZATRATList);
            $('#valErrorRA').hide();
            for (var j = 0; j < HmViewModel.SelectedLanguageType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                        selectedItem = HmViewModel.SelectedLanguageType()[j];
                        riskAreaObj = new RiskArea(selectedItem);
                        //validate language text boxes
                        if (riskAreaObj.RiskAreaName == "") {
                            $('#valErrorRA').show();
                            $('#valErrorRA').text('Risk Area name in ' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' is required.');
                            return;
                        } else {
                            $('#valErrorRA').text('');
                        }

                        HmViewModel.RiskAreaSubList.push(riskAreaObj);
                    }
                }
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            AddRiskAreaAjax = {
                url: "/api/Configuration/AddRiskArea",
                type: "POST",
                data: {
                    RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName(), RiskAreaType: selectedassessmetId,
                    RiskAreaNotes: data.RiskAreaNotes(), IsQualitative: "0", RiskAreaSubList: HmViewModel.RiskAreaSubList(),
                    ZATRATModelObj: HmViewModel.SelectedZATRATList()
                },
                headers: headers,
                async: false
            };
            $.ajax(AddRiskAreaAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in addRiskArea() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.Incident_Description == null) {

                    if (jsonResult.Flag == 1) {
                        logger.logSuccess('Risk Area added successfully.', 'Success', system.getModuleId(HmViewModel), true);
                        HmViewModel.AddAreaFlag(true);
                        GetAllRiskAreas();
                    }

                }
                else if (jsonResult.Incident_Description == null && jsonResult.Flag == 0) {
                    logger.logError(data.RiskAreaName() + 'already exists. Please enter a different Risk Area.', 'Error', system.getModuleId(HmViewModel), true);

                }
                else {
                    if (jsonResult.Incident_Description != null) {
                        var msg = 'Failed to update Risk Area. Please contact your Application Administrator.';
                        logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);

                    }
                    else {
                        logger.logError('Failed to Add Risk Area.', 'Error', system.getModuleId(HmViewModel), true);
                    }

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addRiskArea() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addRiskArea() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in addRiskArea() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }

    }

    function addNewDivTab(data) {
        try {
            $('#adddivtabdiv ul').append(
                '<li id="' + data.RiskAreaId() + '"><a id="' + data.RiskAreaId() + '" href="#adddivtabbody">' + data.RiskAreaName() + '</a></li>'
            );
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTab() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function TabClick(event) {
        try {
            HmViewModel.SelectedLanguageSubFactorType([]);
            HmViewModel.SubFactorRiskAreaList([]);
            //$("#adddivtabbody").show();
            var ClickedRiskAreaId = event.currentTarget.firstChild.attributes['publicid'].value;
            HmViewModel.CurrentRiskAreaId('');
            HmViewModel.CurrentRiskAreaId(ClickedRiskAreaId);
            for (var i = 0, j = HmViewModel.RiskAreaList().length; i < j; i++) {
                if (HmViewModel.RiskAreaList()[i].RiskAreaId() == ClickedRiskAreaId) {
                    HmViewModel.CurrentRiskAreaType(HmViewModel.RiskAreaList()[i].MappedAssessmentType());
                    GetFactorTabData(HmViewModel.RiskAreaList()[i]);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: TabClick() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function GetFactorTabData(data) {
        try {
            var Assessment = "";
            for (var k = 0; k < HmViewModel.AssessmentTypeList().length; k++) {
                for (var f = 0; f < data.MappedAssessmentType().length; f++) {
                    if (parseInt(HmViewModel.AssessmentTypeList()[k].AssessmentId()) == data.MappedAssessmentType()[f].ID) {

                        if (k == 0)
                            Assessment += HmViewModel.AssessmentTypeList()[k].AssessmentName();
                        else {
                            if (Assessment == "") {
                                Assessment += HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                            else {
                                Assessment += ", " + HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                        }
                    }
                }
            }
            
            document.getElementById('AssessmentApplicabilityofArea').innerHTML = Assessment;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetFactorTabData() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //function riskSubFactorsortordercancel
    function CancelRiskSubFactorSortOrder() {
        try {
            // HmViewModel.RiskSubFactorSortOrder(0);
            HmViewModel.RiskSubFactorReorderList([]);
            // HmViewModel.RiskAreaReorderList(HmViewModel.RiskAreaReorderListDup());
            var MappedFactorSortMOdelDup = $.map(HmViewModel.RiskSubFactorReorderListDup(), function (result) {
                return new RiskSubFactorSortModelDup(result);
            });
            HmViewModel.RiskSubFactorReorderList(MappedFactorSortMOdelDup);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelRiskSubFactorSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //function riskfactorsortordercancel
    function CancelRiskFactorSortOrder() {
        try {
            // HmViewModel.RiskFactorSortOrder(0);
            HmViewModel.RiskFactorReorderList([]);
            var MappedFactorSortMOdelDup = $.map(HmViewModel.RiskFactorReorderListDup(), function (result) {
                return new RiskFactorSortOrderDupModel(result);
            });
            // HmViewModel.RiskAreaReorderList(HmViewModel.RiskAreaReorderListDup());
            HmViewModel.RiskFactorReorderList(MappedFactorSortMOdelDup)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelRiskFactorSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //riskareasortordercancel
    function CancelRiskAreaSortOrder() {
        try {
            // HmViewModel.RiskAreaSortOrder(0);
            var MappedControlAreaSortMOdelDup = $.map(HmViewModel.RiskAreaReorderListDup(), function (result) {
                return new RiskAreaSortOrderDupModel(result);
            });
            HmViewModel.RiskAreaReorderList([]);
            // HmViewModel.RiskAreaReorderList(HmViewModel.RiskAreaReorderListDup());
            HmViewModel.RiskAreaReorderList(MappedControlAreaSortMOdelDup);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelRiskAreaSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //riskfactorsortordersave
    function SaveRiskFactorSortOrder() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/RiskFactorSortOrder",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(HmViewModel.RiskFactorReorderList(), function (item) {
                    return { RiskFactorId: item.RiskFactorId(), SortOrder: item.SortOrder() };
                }))
            })
                .success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult != "1") {
                            $('#frmRiskFactorReordermodel').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            for (var i = 0, j = HmViewModel.RiskAreaList().length; i < j; i++) {
                                if (HmViewModel.RiskAreaList()[i].RiskAreaId() == HmViewModel.CurrentRiskAreaId()) {
                                    //  HmViewModel.CurrentRiskAreaType(HmViewModel.RiskAreaList()[i].RiskAreaType());

                                    GetFactorTabData(HmViewModel.RiskAreaList()[i]);
                                    GetRiskFactors(HmViewModel.CurrentRiskAreaId());
                                }
                            }
                            ko.applyBindingsToNode($('#btnfReorder'), { disabled: true, click: HmViewModel.OpenRiskFactorOrderPopup }, HmViewModel);
                            ko.applyBindingsToNode($('#btnAddRf'), { disabled: true, click: HmViewModel.ShowFactorPopUp }, HmViewModel);
                            //GetFactorTabData(HmViewModel.RiskAreaList()[i]);
                            // GetRiskFactors(HmViewModel.RiskAreaId());
                            logger.logSuccess('Sort Order saved successfully', 'Success', system.getModuleId(HmViewModel), true);
                        }
                        else {
                            if (jsonResult.startsWith('INC')) {
                                var msg = 'Error Occured. Please contact your Application Administrator.';
                                logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                            }
                            else {
                                logger.logError('Error Occured. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                            }
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in savesortorder() method in Businessunit.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in edit operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in savesortorder() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveSortOrder() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }


    function BulkUploadQuantTemplateDownload(data, event) {
        try {
            var RiskAreaName;
            for (var i = 0; i < data.RiskAreaList().length; i++) {
                if (parseInt(data.RiskAreaId()) == data.RiskAreaList()[i].RiskAreaId()) {
                    RiskAreaName = data.RiskAreaList()[i].RiskAreaName();
                    break;
                }
            }
            var payLoad = {
                t: appsecurity.getAuthenticationInfo(), RiskAreaId: parseInt(data.RiskAreaId()), RiskAreaName: RiskAreaName
            };
            utils.postAndRedirect(rootPath + "/FileDownload/GetQuantBulkUploadExcel", payLoad, '_blank');

        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | BulkUploadQuantTemplateDownload() in RiskAreasfactors.js';
            logger.logMessage(msg);
        }
    }


    //risksubfactorsortordersave
    function SaveRiskSubFactorSortOrder() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/RiskSubFactorSortOrder",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(HmViewModel.RiskSubFactorReorderList(), function (item) {
                    return { RiskSubFactorId: item.RiskSubfactorId(), SortOrder: item.SortOrder() };
                }))
            })
                .success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult != "1") {
                            $('#frmRiskSubFactorReordermodel').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);
                            logger.logSuccess('Sort Order saved successfully.', 'Success', system.getModuleId(HmViewModel), true);
                        }
                        else {
                            if (jsonResult.startsWith('INC')) {
                                var msg = 'Error Occured. Please contact your Application Administrator.';
                                logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                            }
                            else {
                                logger.logError('Error Occured. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                            }
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in savesortorder() method in Businessunit.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in savesortorder() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveRiskSubFactorOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //riskareasortordersave
    function SaveRiskAreaSortOrder() {

        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/RiskAreaSortOrder?SurveyCategoryId=" + HmViewModel.InherentSetupQuantObj().SurveyCategoryId(),
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(HmViewModel.RiskAreaReorderList(), function (item) {
                    return { RiskAreaId: item.RiskAreaId(), SortOrder: item.SortOrder() };
                }))
            })
                .success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult != "1") {
                            $('#frmRiskAreaReordermodel').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            logger.logSuccess('Sort Order saved successfully.', 'Success', system.getModuleId(HmViewModel), true);
                            GetAllRiskAreas();

                        }
                        else {
                            if (jsonResult.startsWith('INC')) {
                                var msg = 'Error Occured. Please contact your Application Administrator.';
                                logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);

                            }
                            else {
                                logger.logError('Error Occured. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                            }
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in savesortorder() method in Businessunit.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in savesortorder() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveSortOrder() method in BusinessUnit.js';
            logger.logMessage(msg);
        }

    }
    function GetAllRiskAreas() {
        try {
            $.ajax(GetAllRiskAreaAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                $('#loadingMainImgDiv').hide();
                $('#error').hide();
                if (jsonResult != null && jsonResult[0].Flag === 0) {
                    $('#loadingMainImgDiv').hide();
                    $('#error').show();
                    logger.logError('No Risk Areas have been configured.', 'Error', system.getModuleId(HmViewModel), true);
                }
                else if (jsonResult != null && jsonResult[0].RiskAreaId != null) {
                    var currentTabId = "";
                    if ($("#adddivtabdiv").tabs("option", "active") === false) {
                        currentTabId = 0;
                    }
                    else {
                        currentTabId = $("#adddivtabdiv").tabs("option", "active");
                    }
                    $('#adddivtab').empty();
                    HmViewModel.RiskAreaList([]);
                    HmViewModel.RiskAreaReorderListDup([]);
                    HmViewModel.RiskAreaReorderList([]);
                    HmViewModel.RiskAreaSortOrder(0);
                    HmViewModel.RiskAreaSubList([]);


                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        addNewDivTab(RiskAreaModelObj);
                        return RiskAreaModelObj;
                    });
                    var mappedRiskAreaReOrderList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaReorderModel(result);
                        return RiskAreaModelObj;
                    });
                    HmViewModel.RiskAreaSortOrder(0);
                    var mappedDupRiskAreaReOrderList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaReorderModel(result);
                        return RiskAreaModelObj;
                    });
                    HmViewModel.RiskAreaReorderListDup(mappedDupRiskAreaReOrderList);
                    HmViewModel.RiskAreaReorderList(mappedRiskAreaReOrderList);

                    HmViewModel.RiskAreaList(mappedRiskAreaList);
                    // scrollableTabs();
                    if (currentTabId >= $('#adddivtab >li').length || HmViewModel.AddAreaFlag() === true)
                        currentTabId = parseInt($('#adddivtab >li').length) - 1;
                    $('#loadingMainImgDiv').hide();

                    $("#adddivtabdiv").tabs();
                    $('#adddivtabdiv').tabs('refresh');
                    $('#adddivtabdiv').tabs({ active: currentTabId });
                    $($('#adddivtabdiv li').get(currentTabId)).trigger('click');
                    scrollableTabs();
                }
                else if (jsonResult[0].RiskAreaId == 0 && jsonResult[0].RiskAreaName == null) {
                    $('#loadingMainImgDiv').hide();
                    $('#error').show();
                    $('#adddivtab').empty();
                    $('#adddivtabbody').empty();
                    HmViewModel.RiskAreaList([]);
                    HmViewModel.RiskAreaReorderListDup([]);
                    HmViewModel.RiskAreaReorderList([]);
                    HmViewModel.RiskAreaSortOrder(0);
                }
                HmViewModel.AddAreaFlag(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetRiskFactors(RiskAreaId) {
        try {

            var RAT = ko.toJSON(HmViewModel.CurrentRiskAreaType()).replace("[", "").replace("]", "").toString();
            HmViewModel.RiskAreaId(RiskAreaId);
            GetAllRiskFactorAjax = {
                url: "/api/Configuration/GetAllRiskfactorAreaWise",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                async: false,
                data: {
                    "RiskAreaId": RiskAreaId, "SurveyCategoryID": HmViewModel.ZATRATList()[0].ZAT_UID,
                    "AssessmentTypes": RAT, "ScreenType": null
                }
            };
            GetAllRiskFactor(GetAllRiskFactorAjax);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetRiskFactors() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskFactor(GetAllRiskFactorAjax) {
        try {
            $.ajax(GetAllRiskFactorAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                    HmViewModel.SelectedLanguageFactorType([]),
                        HmViewModel.FactorRiskAreaList = {};
                    var mappedRiskFactors = $.map(jsonResult, function (result) {
                        return new RiskFactorModel(result);
                    });
                    HmViewModel.RiskFactorReorderList([]);
                    HmViewModel.RiskFactorReorderListDup([]);
                    HmViewModel.RiskFactorSortOrder(0);
                    var mappedRiskFactorssortOrder = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskFactorSortModel(result);
                        return RiskAreaModelObj;
                    });
                    HmViewModel.RiskFactorSortOrder(0);
                    var mappedRiskFactorsSortOrderDup = $.map(jsonResult, function (result) {
                        var RiskAreaModelObjDup = new RiskFactorSortModel(result);
                        return RiskAreaModelObjDup;
                    });
                    HmViewModel.RiskFactorReorderList(mappedRiskFactorssortOrder);
                    HmViewModel.RiskFactorReorderListDup(mappedRiskFactorsSortOrderDup);

                    tableObj = $('#tblRiskFactor').DataTable();
                    tableObj.destroy();
                    $("#tblRiskFactor tbody tr").remove();
                    HmViewModel.RiskFactorList(mappedRiskFactors);
                    ko.applyBindingsToNode($('#tblRiskFactor tbody .details-control'), { click: HmViewModel.trclick }, HmViewModel);

                    RfTableObj = $('#tblRiskFactor').DataTable({
                        responsive: true,
                        stateSave: true,
                        "aoColumnDefs": [{
                            "aTargets": [0],
                            "bVisible": true,
                            "sClass": "details-control"

                        }, {
                            "aTargets": [1],
                            "bVisible": false,
                            "bSortable": false

                        }]
                    });
                    $('#tblRiskFactor').DataTable().draw(false);
                }
                else {
                    if (jsonResult.length == 0) {
                        HmViewModel.RiskFactorList([]);
                        HmViewModel.RiskFactorReorderList([]);
                        HmViewModel.RiskFactorReorderListDup([]);
                        HmViewModel.RiskFactorSortOrder(0);
                        RfTableObj = $('#tblRiskFactor').DataTable({
                            responsive: true,
                            stateSave: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,
                                //   "bSortable": false,

                                "sClass": "details-control"

                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "bSortable": false

                            }]
                        });
                        $('#tblRiskFactor').DataTable().draw(false);
                    }
                    else {
                        if (jsonResult.length > 0) {
                            HmViewModel.RiskFactorList([]);
                            HmViewModel.RiskFactorReorderList([]);
                            HmViewModel.RiskFactorReorderListDup([]);
                            HmViewModel.RiskFactorSortOrder(0);
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                        }
                        else {
                            HmViewModel.RiskFactorList([]);
                            HmViewModel.RiskFactorReorderList([]);
                            HmViewModel.RiskFactorReorderListDup([]);
                            HmViewModel.RiskFactorSortOrder(0);
                            logger.logError('Error Occured. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }
    }
    //this gets triggered on click of up arrow in risk subfactor re order popup
    function UpFunctionalityRiskSubFactor(data, event) {
        try {
            $('#valErrorSubbbbFactor').hide();
            for (var i = 0; i < HmViewModel.RiskSubFactorReorderList().length; i++) {

                if (data.RiskSubfactorId() == HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId()) {
                    if (i == 0) {
                        $('#valErrorSubbbbFactor').show();
                        document.getElementById('valErrorSubbbbFactor').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId();
                        var y = HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName();

                        HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId(HmViewModel.RiskSubFactorReorderList()[i - 1].RiskSubfactorId());
                        HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName(HmViewModel.RiskSubFactorReorderList()[i - 1].RiskSubfactorName());

                        HmViewModel.RiskSubFactorReorderList()[i - 1].RiskSubfactorId(x);
                        HmViewModel.RiskSubFactorReorderList()[i - 1].RiskSubfactorName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UpFunctionalityRiskSubFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of up arrow in risk factor reorder popup 
    function UpFunctionalityRiskFactor(data, event) {
        try {
            $('#valfactorerror').hide();
            for (var i = 0; i < HmViewModel.RiskFactorReorderList().length; i++) {

                if (data.RiskFactorId() == HmViewModel.RiskFactorReorderList()[i].RiskFactorId()) {
                    if (i == 0) {
                        $('#valfactorerror').show();
                        document.getElementById('valfactorerror').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = HmViewModel.RiskFactorReorderList()[i].RiskFactorId();
                        var y = HmViewModel.RiskFactorReorderList()[i].RiskFactorNameClean();

                        HmViewModel.RiskFactorReorderList()[i].RiskFactorId(HmViewModel.RiskFactorReorderList()[i - 1].RiskFactorId());
                        HmViewModel.RiskFactorReorderList()[i].RiskFactorNameClean(HmViewModel.RiskFactorReorderList()[i - 1].RiskFactorNameClean());

                        HmViewModel.RiskFactorReorderList()[i - 1].RiskFactorId(x);
                        HmViewModel.RiskFactorReorderList()[i - 1].RiskFactorNameClean(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of up arrow in riskarea reorder pop up
    function UpFunctionalityRiskArea(data, event) {
        try {
            $('#valError').hide();
            for (var i = 0; i < HmViewModel.RiskAreaReorderList().length; i++) {

                if (data.RiskAreaId() == HmViewModel.RiskAreaReorderList()[i].RiskAreaId()) {
                    if (i == 0) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = HmViewModel.RiskAreaReorderList()[i].RiskAreaId();
                        var y = HmViewModel.RiskAreaReorderList()[i].RiskAreaName();

                        HmViewModel.RiskAreaReorderList()[i].RiskAreaId(HmViewModel.RiskAreaReorderList()[i - 1].RiskAreaId());
                        HmViewModel.RiskAreaReorderList()[i].RiskAreaName(HmViewModel.RiskAreaReorderList()[i - 1].RiskAreaName());

                        HmViewModel.RiskAreaReorderList()[i - 1].RiskAreaId(x);
                        HmViewModel.RiskAreaReorderList()[i - 1].RiskAreaName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpFunctionalityRiskArea() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function InputChangedArea(data, event) {
        try {
            $('#valError').hide();
            if (!isNaN(data.SortOrder()) && data.SortOrder() <= HmViewModel.RiskAreaReorderList().length && data.SortOrder() > 0) {


                var riskareacount = HmViewModel.RiskAreaReorderList().length - 1;
                HmViewModel.RiskAreaReorderList.remove(function (item) { return item.RiskAreaId() == data.RiskAreaId() })
                HmViewModel.RiskAreaSortOrder(0);
                var count = data.SortOrder() - 1;
                var counter = 1;
                var MappedRiskAreaModel1 = $.map(HmViewModel.RiskAreaReorderList(), function (result) {
                    if (counter <= count) {
                        counter++;
                        return new RiskAreaReorderModel(result);
                    }

                });
                var ChangedModel = new RiskAreaReorderModel({ SortOrder: data.SortOrder(), RiskAreaName: data.RiskAreaName(), RiskAreaId: data.RiskAreaId() })
                var Model = [];
                if (MappedRiskAreaModel1.length > 0) {
                    for (var i = 0; i < MappedRiskAreaModel1.length; i++) {
                        var NewModel = new RiskAreaReorderModelSortOrder({
                            SortOrder: MappedRiskAreaModel1[i].SortOrder(), RiskAreaName: MappedRiskAreaModel1[i].RiskAreaName(), RiskAreaId: MappedRiskAreaModel1[i].RiskAreaId()
                        });
                        Model.push(NewModel);
                    }
                }
                Model.push(ChangedModel);
                var count = Model.length;
                for (var k = count; k < riskareacount + 1; k++) {
                    var ChangedModel = new RiskAreaReorderModel({
                        SortOrder: HmViewModel.RiskAreaReorderList()[k - 1].SortOrder(), RiskAreaName: HmViewModel.RiskAreaReorderList()[k - 1].RiskAreaName(), RiskAreaId: HmViewModel.RiskAreaReorderList()[k - 1].RiskAreaId()
                    })
                    Model.push(ChangedModel);
                }
                HmViewModel.RiskAreaReorderList([]);
                HmViewModel.RiskAreaReorderList(Model);
            }
            else {
                $('#valError').show();
                $('#valError').html("Please enter a valid number")
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedArea() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    function InputChangedFactor(data, event) {
        try {
            $('#valfactorerror').hide();
            if (!isNaN(data.SortOrder()) && data.SortOrder() <= HmViewModel.RiskFactorReorderList().length && data.SortOrder() > 0) {
                var riskFactorCount = HmViewModel.RiskFactorReorderList().length - 1;
                HmViewModel.RiskFactorReorderList.remove(function (item) { return item.RiskFactorId() == data.RiskFactorId() })
                HmViewModel.RiskFactorSortOrder(0);
                var count = data.SortOrder() - 1;
                var counter = 1;
                var MappedRiskFactorModel1 = $.map(HmViewModel.RiskFactorReorderList(), function (result) {
                    if (counter <= count) {
                        counter++;
                        return new RiskFactorSortModel(result);
                    }

                });

                var ChangedModel = new RiskFactorSortModel({ SortOrder: data.SortOrder(), RiskFactorNameClean: data.RiskFactorNameClean(), RiskAreaId: data.RiskAreaId(), RiskFactorId: data.RiskFactorId() })
                var Model = [];
                if (MappedRiskFactorModel1.length > 0) {
                    for (var i = 0; i < MappedRiskFactorModel1.length; i++) {
                        var NewModel = new RiskFactorReorderModelSortOrder({
                            SortOrder: MappedRiskFactorModel1[i].SortOrder(), RiskAreaId: MappedRiskFactorModel1[i].RiskAreaId(), RiskFactorNameClean: MappedRiskFactorModel1[i].RiskFactorNameClean(), RiskFactorId: MappedRiskFactorModel1[i].RiskFactorId()
                        });
                        Model.push(NewModel);
                    }
                }
                Model.push(ChangedModel);
                var count = Model.length;
                for (var k = count; k < riskFactorCount + 1; k++) {
                    var ChangedModel = new RiskFactorSortModel({
                        SortOrder: HmViewModel.RiskFactorReorderList()[k - 1].SortOrder(), RiskFactorNameClean: HmViewModel.RiskFactorReorderList()[k - 1].RiskFactorNameClean(), RiskFactorId: HmViewModel.RiskFactorReorderList()[k - 1].RiskFactorId(), RiskAreaId: HmViewModel.RiskFactorReorderList()[k - 1].RiskAreaId()
                    })
                    Model.push(ChangedModel);
                }
                HmViewModel.RiskFactorReorderList([]);
                HmViewModel.RiskFactorReorderList(Model);
            }
            else {
                $('#valfactorerror').show();
                $('#valfactorerror').html("Please enter a valid number")
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function InputChangedSubFactor(data, event) {
        try {
            $('#valErrorSubbbbFactor').hide();
            if (!isNaN(data.SortOrder()) && data.SortOrder() <= HmViewModel.RiskSubFactorReorderList().length && data.SortOrder() > 0) {
                var riskSubFactorCount = HmViewModel.RiskSubFactorReorderList().length - 1;
                HmViewModel.RiskSubFactorReorderList.remove(function (item) { return item.RiskSubfactorId() == data.RiskSubfactorId() })
                HmViewModel.RiskSubFactorSortOrder(0);
                var count = data.SortOrder() - 1;
                var counter = 1;
                var MappedRiskFactorModel1 = $.map(HmViewModel.RiskSubFactorReorderList(), function (result) {
                    if (counter <= count) {
                        counter++;
                        return new RiskSubFactorSortModel(result);
                    }

                });

                var ChangedModel = new RiskSubFactorSortModel({ SortOrder: data.SortOrder(), RiskFactorId: data.RiskFactorId(), RiskSubfactorId: data.RiskSubfactorId(), RiskSubfactorName: data.RiskSubfactorName() })
                var Model = [];
                if (MappedRiskFactorModel1.length > 0) {
                    for (var i = 0; i < MappedRiskFactorModel1.length; i++) {
                        var NewModel = new RiskSubFactorReorderModelSortOrder({
                            SortOrder: MappedRiskFactorModel1[i].SortOrder(), RiskFactorId: MappedRiskFactorModel1[i].RiskFactorId(), RiskSubfactorName: MappedRiskFactorModel1[i].RiskSubfactorName(), RiskSubfactorId: MappedRiskFactorModel1[i].RiskSubfactorId()
                        });
                        Model.push(NewModel);
                    }
                }
                Model.push(ChangedModel);
                var count = Model.length;
                for (var k = count; k < riskSubFactorCount + 1; k++) {
                    var ChangedModel = new RiskSubFactorSortModel({
                        SortOrder: HmViewModel.RiskSubFactorReorderList()[k - 1].SortOrder(), RiskFactorId: HmViewModel.RiskSubFactorReorderList()[k - 1].RiskFactorId(), RiskSubfactorName: HmViewModel.RiskSubFactorReorderList()[k - 1].RiskSubfactorName(), RiskSubfactorId: HmViewModel.RiskSubFactorReorderList()[k - 1].RiskSubfactorId()
                    })
                    Model.push(ChangedModel);
                }
                HmViewModel.RiskSubFactorReorderList([]);
                HmViewModel.RiskSubFactorReorderList(Model);
            }
            else {
                $('#valErrorSubbbbFactor').show();
                $('#valErrorSubbbbFactor').html("Please enter a valid number")
            }


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of down arrow in riskarea reorder pop up
    function DownFunctionalityRiskArea(data, event) {
        try {
            $('#valError').hide();
            for (var i = 0; i < HmViewModel.RiskAreaReorderList().length; i++) {

                if (data.RiskAreaId() == HmViewModel.RiskAreaReorderList()[i].RiskAreaId()) {
                    if (i == HmViewModel.RiskAreaReorderList().length - 1) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further DOWN";
                    }
                    else {
                        var x = HmViewModel.RiskAreaReorderList()[i].RiskAreaId();
                        var y = HmViewModel.RiskAreaReorderList()[i].RiskAreaName();

                        HmViewModel.RiskAreaReorderList()[i].RiskAreaId(HmViewModel.RiskAreaReorderList()[i + 1].RiskAreaId());
                        HmViewModel.RiskAreaReorderList()[i].RiskAreaName(HmViewModel.RiskAreaReorderList()[i + 1].RiskAreaName());

                        HmViewModel.RiskAreaReorderList()[i + 1].RiskAreaId(x);
                        HmViewModel.RiskAreaReorderList()[i + 1].RiskAreaName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownFunctionalityRiskArea() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of down arrow in risksubfactor reorder pop up
    function DownFunctionalityRiskSubFactor(data, event) {
        try {
            $('#valErrorSubbbbFactor').hide();
            for (var i = 0; i < HmViewModel.RiskSubFactorReorderList().length; i++) {

                if (data.RiskSubfactorId() == HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId()) {
                    if (i == HmViewModel.RiskSubFactorReorderList().length - 1) {
                        $('#valErrorSubbbbFactor').show();
                        document.getElementById('valErrorSubbbbFactor').innerHTML = "This cannot go further Down";
                    }
                    else {
                        var x = HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId();
                        var y = HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName();

                        HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId(HmViewModel.RiskSubFactorReorderList()[i + 1].RiskSubfactorId());
                        HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName(HmViewModel.RiskSubFactorReorderList()[i + 1].RiskSubfactorName());

                        HmViewModel.RiskSubFactorReorderList()[i + 1].RiskSubfactorId(x);
                        HmViewModel.RiskSubFactorReorderList()[i + 1].RiskSubfactorName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DownFunctionalityRiskSubFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of down arrow in riskfactor reorder pop up 
    function DownFunctionalityRiskFactor(data, event) {

        try {
            $('#valfactorerror').hide();
            for (var i = 0; i < HmViewModel.RiskFactorReorderList().length; i++) {

                if (data.RiskFactorId() == HmViewModel.RiskFactorReorderList()[i].RiskFactorId()) {
                    if (i == HmViewModel.RiskFactorReorderList().length - 1) {
                        $('#valfactorerror').show();
                        document.getElementById('valfactorerror').innerHTML = "This cannot go further Down";
                    }
                    else {
                        var x = HmViewModel.RiskFactorReorderList()[i].RiskFactorId();
                        var y = HmViewModel.RiskFactorReorderList()[i].RiskFactorNameClean();

                        HmViewModel.RiskFactorReorderList()[i].RiskFactorId(HmViewModel.RiskFactorReorderList()[i + 1].RiskFactorId());
                        HmViewModel.RiskFactorReorderList()[i].RiskFactorNameClean(HmViewModel.RiskFactorReorderList()[i + 1].RiskFactorNameClean());

                        HmViewModel.RiskFactorReorderList()[i + 1].RiskFactorId(x);
                        HmViewModel.RiskFactorReorderList()[i + 1].RiskFactorNameClean(y);
                        break;
                    }
                }
            }

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DownFunctionalityRiskFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    // Add Response Type
    function AddResponseType() {
        try {
            var responseType = HmViewModel.editableResponseTypes().length + 1;
            HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                ResponseId: 0,
                Rank: responseType,
                ResponseType: "RESPONSE" + responseType,
                description: "",
                calculationapplicability: true,
                currencyapplicability: false,
                weightings: 0,
                response: "",
                Weightedaverageflag: HmViewModel.WeightedAverageType(),
                isGlobalFlag: HmViewModel.isGlobalFlag()
            }));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //Response type popup save button
    function SaveResponseType(data) {
        try {

            $('#rspError1').hide();
            $('#rspError2').hide();
            //if (ValidateResponses(data)) {
            SaveQuanResponseDetails(data);
            //}

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //deleteResponseButton

    function deleteResponseButton(data) {
        try {
            app.showMessage('Are you sure you want to Delete this Response Level?' + "<br/><br/><b>", 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        deleteResponseItem(data);

                    }
                });
            setTimeout(function () {
                document.getElementById(event.target.id).focus();
            }, 1);
            event.preventDefault;
            event.stopImmediatePropagation;
            event.stopPropagation;
            return false;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteResponseButton() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    //deleteResponseItem

    function deleteResponseItem(data) {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            deleteQuanResponseType = {
                url: "/api/Configuration/deleteQuanResponseItem",
                type: "POST",
                data: { RESPONSE_ID: data.ResponseId(), RESPONSE_DESCRIPTION: data.description() },
                headers: headers,
                async: false
            };
            $.ajax(deleteQuanResponseType)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in deleteResponseItem() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "2") {
                    logger.logError('The Response cannot be deleted as it is used in the Application.', 'Error', system.getModuleId(HmViewModel), true);

                }
                else if (jsonResult != null) {
                    OpenConfigureResponseTypePopup();
                }
                else {
                    if (jsonResult.startsWith('INC')) {
                        var msg = 'An error occurred. Please contact your Application Administrator.';
                        logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteResponseItem() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteResponseItem() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteResponseItem() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }

        }
    }





    function SaveQuanResponseDetails(data) {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveQuanResponseDetails",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(HmViewModel.editableResponseTypes(), function (item) {
                    return {
                        ResponseId: item.ResponseId(),
                        Rank: item.Rank(),
                        ResponseType: item.ResponseType(),
                        description: item.description(),
                        calculationapplicability: item.calculationapplicability(),
                        currencyapplicability: item.currencyapplicability(),
                        weightings: item.weightings(),
                        response: item.response(),
                        Weightedaverageflag: HmViewModel.WeightedAverageType(),
                        SimpleAverageflag: HmViewModel.SimpleAverageType(),
                        isGlobalFlag: HmViewModel.isGlobalFlag()
                    };
                }))
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveQuanResponseDetails() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "1") {

                    $('#frmResponseTypemodel').modal('hide');
                    $('#modalContent').css({
                        'margin-top': '25%'
                    });
                    logger.logSuccess('Response types saved successfully.', 'Success', system.getModuleId(HmViewModel), true);
                }
                else {
                    if (jsonResult.startsWith('INC')) {
                        var msg = 'An error occurred. Please contact your Application Administrator.';
                        logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }

        }
    }


    //Response type validate method
    function ValidateResponses(data) {
        try {
            var error = 0;
            var wtSum = 0;
            for (var i = 0; i < HmViewModel.editableResponseType().length; i++) {
                if (HmViewModel.editableResponseType()[i].calculationapplicability() == 1) {
                    if (HmViewModel.editableResponseType()[i].response() == "") {
                        error++;
                    }
                    else if (HmViewModel.editableResponseType()[i].description() == "") {
                        error++;
                    }
                    if (HmViewModel.WeightedAverageType()) {
                        wtSum = wtSum + parseFloat(HmViewModel.editableResponseType()[i].weightings());
                    }
                }

            }
            if (HmViewModel.WeightedAverageType()) {
                if (wtSum != 100) {
                    $('#rspError').html('The sum of the weightings should be 100.');
                    $('#rspError').show();
                    return false;
                }
                else {
                    $('#rspError').html('');
                    $('#rspError').hide();
                    return true;
                }
            }
            if (error > 0) {
                $('#rspError').html('Please fill the required fields.');
                $('#rspError').show();
                return false;
            }
            else {
                $('#rspError').html('');
                $('#rspError').hide();
                return true;
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //Average type radio button click
    function Avgtyperdbchanged(data, event) {
        try {
            //Toggle the weighted average flag
            document.getElementById(event.currentTarget.id).checked = true;
            if (event.currentTarget.value == "SimpleAverage") {
                HmViewModel.WeightedAverageType(false);
            }
            else {
                HmViewModel.WeightedAverageType(true);
            }
            return true;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function isGlobalFlagChange(data, event) {
        try {
            document.getElementById(event.currentTarget.id).checked = true;
            HmViewModel.isGlobalFlag(!HmViewModel.isGlobalFlag());
            if (HmViewModel.isGlobalFlag()) {

            }
            return true;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: isGlobalFlagChange() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //Response applicability checkbox for third response click
    function responsepapplicabilityclick(data, event) {
        try {

            if (data.calculationapplicability3() && $('#WghtdAvg').is(':checked')) {
                $('#rspweightings3').attr('disabled', false);
            }

            else {
                $('#rspweightings3').attr('disabled', true);
            }

            return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: responsepapplicabilityclick() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }



    function RiskAreaSortOrderDupModel(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder());
            self.RiskAreaName = ko.observable(item.RiskAreaName());
            self.RiskAreaId = ko.observable(item.RiskAreaId());
            HmViewModel.RiskAreaSortOrder(HmViewModel.RiskAreaSortOrder() + 1);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaSortOrderDupModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskAreaReorderModel(item) {
        var self = this;
        self.SortOrder = ko.observable(HmViewModel.RiskAreaSortOrder() + 1);
        if (item.RiskAreaName.length > 0)
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
        else
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName()).text());
        self.RiskAreaId = ko.observable(item.RiskAreaId);
        HmViewModel.RiskAreaSortOrder(HmViewModel.RiskAreaSortOrder() + 1);
    }


    function RiskAreaReorderModelSortOrder(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder);
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaReorderModelSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskFactorReorderModelSortOrder(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder);
            self.RiskFactorNameClean = ko.observable($('<div/>').html(item.RiskFactorNameClean).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId());
            self.RiskFactorId = ko.observable(item.RiskFactorId());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorReorderModelSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskAreaModel(item) {
        try {
            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                    return new AssessmentModel(result);
                });
            }
            self.MappedAssessmentType = ko.observableArray(MappedAssessments);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.AMLRank = ko.observable($('<div/>').html(item.AMLRank).text());
            self.SANCRank = ko.observable($('<div/>').html(item.SANCRank).text());
            self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
            self.TargetRow = ko.observable();
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.RiskAreaSubList = ko.observableArray(item.RiskAreaSubList);
            self.ZATIdList = ko.observable(item.ZATIdList);
            self.ZATNames = ko.observable(item.ZATNames);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function AssessmentModel(item) {
        try {
            var self = this;
            if (isNaN(item)) {
                self.ID = item.ID
            }
            else {
                self.ID = item;
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorSortOrderDupModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskFactorSortOrderDupModel(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder());
            self.RiskFactorNameClean = ko.observable(item.RiskFactorNameClean());
            self.RiskFactorId = ko.observable(item.RiskFactorId());
            self.RiskAreaId = ko.observable(item.RiskAreaId());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorSortOrderDupModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactorSortModel(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(HmViewModel.RiskFactorSortOrder() + 1);
            if (item.RiskFactorNameClean.length > 0)
                self.RiskFactorNameClean = ko.observable($('<div/>').html(item.RiskFactorNameClean).text());
            else
                self.RiskFactorNameClean = ko.observable($('<div/>').html(item.RiskFactorNameClean()).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            HmViewModel.RiskFactorSortOrder(HmViewModel.RiskFactorSortOrder() + 1);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorSortModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorNameClean).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                    return new AssessmentModel(result);
                });
            }
            self.MappedAssessmentType = ko.observableArray(MappedAssessments);
            self.AMLNumbering = ko.observable($('<div/>').html(item.AMLRank).text());
            self.SANCNumbering = ko.observable($('<div/>').html(item.SANCRank).text());

            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            //if (item.AssessmentType == "SANC") {
            //    self.AssessmentType = ko.observable('Sanctions');
            //}
            //else if (item.AssessmentType == "BOTH") {
            //    self.AssessmentType = ko.observable('Both');
            //}
            //else {
            //    self.AssessmentType = ko.observable(item.AssessmentType);
            //}
            self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
            self.TargetRow = ko.observable();
            self.FactorRiskAreaList = ko.observableArray(item.RiskAreaSubList);
            self.ZATIdList = ko.observable(item.ZATIdList);
            self.ZATNames = ko.observable(item.ZATNames);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function RiskSubFactorSortModelDup(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder());
            self.RiskFactorId = ko.observable(item.RiskFactorId());
            self.RiskSubfactorId = ko.observable(item.RiskSubfactorId());
            self.RiskSubfactorName = ko.observable(item.RiskSubfactorName());
        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: RiskSubFactorSortModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskSubFactorReorderModelSortOrder(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder);
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskSubfactorId = ko.observable(item.RiskSubfactorId);
            self.RiskSubfactorName = ko.observable($('<div/>').html(item.RiskSubfactorName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskSubFactorReorderModelSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskSubFactorSortModel(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(HmViewModel.RiskSubFactorSortOrder() + 1);
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskSubfactorId = ko.observable(item.RiskSubfactorId);
            if (item.RiskSubfactorName.length > 0)
                self.RiskSubfactorName = ko.observable($('<div/>').html(item.RiskSubfactorName).text());
            else
                self.RiskSubfactorName = ko.observable($('<div/>').html(item.RiskSubfactorName()).text());

            HmViewModel.RiskSubFactorSortOrder(HmViewModel.RiskSubFactorSortOrder() + 1);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskScoreModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function QuanResponseColumnDetails(item) {
        try {
            var self = this;
            self.ResponseId = ko.observable(item.ResponseId);
            self.ResponseType = ko.observable(item.ResponseType);
            self.calculationapplicability = ko.observable(item.calculationapplicability);
            self.weightings = ko.observable(item.weightings);
            self.response = ko.observable(item.response);
            self.SimpleAverageflag = ko.observable(item.SimpleAverageflag);
            self.AssessmentType = ko.observable(item.AssessmentType);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.description = ko.observable("");
            self.currencyapplicability = ko.observable(false);
            self.Rank = ko.observable(0);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuanResponseColumnDetails() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function QuantitativeResponseColumnsModel(item) {
        try {
            var self = this;
            self.ResponseId = ko.observable(item.ResponseId);
            self.Rank = ko.observable(item.Rank);
            self.ResponseType = ko.observable(item.ResponseType);
            self.description = ko.observable(item.description);
            self.calculationapplicability = ko.observable(item.calculationapplicability);
            self.currencyapplicability = ko.observable(item.currencyapplicability);
            self.weightings = ko.observable(item.weightings);
            self.response = ko.observable(item.response);
            self.SimpleAverageflag = ko.observable(item.SimpleAverageflag);
            self.isGlobalFlag = ko.observable(item.isGlobalFlag);
            self.AssessmentType = ko.observable(item.AssessmentType);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseColumnsModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function ResponseColumnsModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable(item.AssessmentId());
            self.AssessmentType = ko.observable(item.AssessmentName());
            self.AssessmentColumn = ko.observable(item.AssessmentName() + "Applicability");
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseColumnsModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }



    function RiskSubFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskSubfactorId = ko.observable(item.RiskSubfactorId);
            self.RiskSubfactorName = ko.observable($('<div/>').html(item.RiskSubfactorName).text());
            self.RiskSubfactorMatchId = ko.observable(item.RiskSubfactorMatchId);
            self.RuleId = ko.observable($('<div/>').html(item.RULE_ID).text());
            self.RuleCategoryCode = ko.observable($('<div/>').html(item.RULE_CATEGORY_CODE).text());
            self.RuleSubCategoryCode = ko.observable($('<div/>').html(item.RULE_SUBCATEGORY_CODE).text());

            self.RiskLevel = ko.observable($('<div/>').html(item.RiskLevel).text());
            self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
            self.AssessmentTypeId = ko.observable($('<div/>').html(item.AssessmentTypeId).text());
            self.RiskMapping = ko.observable($('<div/>').html(item.RiskMapping).text());
            self.TargetRow = ko.observable(-1);
            self.RiskAreaSubList = ko.observableArray(item.RiskAreaSubList);
            self.QuestionType = ko.observable(item.QuestionType);
            self.HeaderQuestionFlag = ko.observable(false);
            if (item.QuestionType === 'H') {
                self.HeaderQuestionFlag = ko.observable(true);
            }
            self.QuestionTypeDescription = ko.observable(item.QuestionTypeDescription);
            self.HeaderUID = ko.observable(item.HeaderUID);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskSubFactorModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function RiskScoreModel(item) {
        try {
            var self = this;
            self.Id = ko.observable(item.Id);
            self.DisplayText = ko.observable($('<div/>').html(item.DisplayText).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskScoreModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function SurveyModel(item) {
        try {
            var self = this;
            self.SurveyName = ko.observable($('<div/>').html(item.SurveyName).text());
            self.SurveySecondName = ko.observable($('<div/>').html(item.SurveySecondName).text());
            self.surveyType = ko.observable($('<div/>').html(item.surveyType).text());
            self.SurveyStatus = ko.observable(item.SurveyStatus);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }
    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }
    function FilteredAssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId()).text());
            self.AssessmentName = ko.observable(item.AssessmentName());
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName()).text());
            self.Description = ko.observable($('<div/>').html(item.Description()).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: FilteredAssessmentListModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelName = item.RiskLevelName;
            self.RiskLevelShortText = item.RiskLevelShortText;
            self.ScoringType = item.ScoringType;
            self.LevelCount = item.RiskLevelCount;
            self.AssessmentTypeId = item.AssessmentId;
            self.isQuantitative = item.isQuantitative;
            self.MappedRiskLevels = $.map(item.RiskLevelDetailsModel, function (result) {
                return new InherentRiskLevelModel(result);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }
    function InherentRiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelParentId = item.RiskLevelParentId;
            self.RiskLevelcss = item.RiskLevelcss;
            self.RiskLevelComents = item.RiskLevelComents;
            self.RiskLevelDescription = item.RiskLevel + ' - ' + item.RiskLevelDescription;
            self.RiskLevel = item.RiskLevel;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskLevelModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    function ZATRATModel(ZATID, ZATNAME, RATID) {
        try {
            var self = this;
            self.ZAT_UID = ko.observable(ZATID);
            self.ZATName = ko.observable(ZATNAME);
            self.RAT_UID = ko.observable(RATID);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ZATRATModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskSubFactorHeaderModel(item) {
        try {
            var self = this;
            self.HeaderSubFactorId = ko.observable(item.HeaderSubFactorId);
            self.HeaderSubFactorName = ko.observable(item.HeaderSubFactorName);
            self.ApplicableRATId = ko.observable(item.ApplicableRATId);
            self.ApplicableRATNames = ko.observable(item.ApplicableRATIdNames);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskSubFactorHeaderModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }


    function GetLanguageName(languageId) {
        if (HmViewModel.ObjGeneralSettings.LanguageList().length == 0) {
            HmViewModel.ObjGeneralSettings.getLanguages();
        }
        for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
            if (HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID().toString() === languageId)
                return HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME();
        }
        return ""; // The object was not found
    }
    function ToggleNavigationMenu1() {
        var chk2 = $('#NavigationToggle2');
        chk2.prop("checked", false);
        $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
        $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
        $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
        $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
        $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
        $("#divNavSwitch2").show();
        $("#divjsTree").hide();
    }
    function ToggleNavigationMenu2() {
        var chk1 = $('#NavigationToggle1');
        chk1.prop("checked", true);
        $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
        $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
        $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
        $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
        $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
        $("#divNavSwitch2").hide();
        $("#divjsTree").show();
    }
    function CollapseAllTreeView() {
        if ($('#spanExpandAll').text() == "Expand") {
            $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
            $("#spanExpandAll").text("Collapse");
        }
        else {
            $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
            $("#spanExpandAll").text("Expand");
        }
    }
    function ExpandAllTreeView() {
        $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
    }


    function InitiateAreaLevelTree(AssessmentIdList) {
        var csrfToken = $("input[name='__RequestVerificationToken']").val();
        var headers = appsecurity.getSecurityHeaders();
        headers.__RequestVerificationToken = csrfToken;
        getJsTreeAreaLevel = {
            url: "/api/Configuration/GetEALData",
            type: "GET",
            data: {
                RiskAreType: 'QTDR', SurveyCategoryID: HmViewModel.ZATRATList()[0].ZAT_UID,
                AssessmentTypes: AssessmentIdList, ScreenType: 'QTDR'
            },
            headers: headers
        };
        $.ajax(getJsTreeAreaLevel)
            .success(ajaxSuccess)
            .fail(ajaxFail);

        function ajaxSuccess(jsonResult, status) {

            $('#loadingMainImgDiv').hide();
            $('#error').hide();
            if (jsonResult.Incident_Description == null) {
                //implement js tree logic here
                HmViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                    return new jsTreeModel(result);
                });

                $('#jsTreeAreaLevel').treeview({
                    data: MappedJsTreeList,
                    onNodeSelected: nodeClickEvent
                });
                var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                HmViewModel.hasChildNodes(hasChildNodes);
                //for initial load expand for treeview
                $("#jsTreeAreaLevel ul:first li:first").trigger("click");

            }
            else {
                if (jsonResult == null || jsonResult == undefined) {
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);

                }
                else {
                    var msg = 'An error occurred. Please contact your Application Administrator.';
                    logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(HmViewModel), true);
                }
            }

        }

        function nodeClickEvent(event, node) {
            // Your logic goes here
            if (node.dead_node == 1) {
                //select node explicitly in case of recursive calling activity. 
                $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);

                HmViewModel.CurrentRiskAreaId(parseInt(node.id));
                $('#loadingMainImgDivFactors').show();
                HmViewModel.SelectedAreaName(node.text);
                HmViewModel.CurrentRiskAreaType(node.assessmentTypeList());
                
                GetRiskFactors(parseInt(node.id));

            } else {
                //recursively opening until the dead_node arrives.
                if (!(node.state.expanded))
                    nodeClickEvent(event, node.nodes[0]);
                $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);


            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, {
                        buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
                    })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

    }

    //ends here 
    function HideFilterDiv() {
        $("#FilterAreaAccordion").hide();

        $("#FilterAreaAccordion").removeClass("col-lg-3");
        $("#FilterAreaAccordion").removeClass("col-md-3");
        $("#FilterAreaAccordion").removeClass("col-sm-3");
        $("#FilterAreaAccordion").removeClass("col-xs-3");

        $("#btnShowFilterDiv").show();


    }

    function ShowFilterDiv() {
        $("#FilterAreaAccordion").show();

        $("#btnShowFilterDiv").hide();
        $("#FilterAreaAccordion").addClass("col-lg-3");
        $("#FilterAreaAccordion").addClass("col-md-3");
        $("#FilterAreaAccordion").addClass("col-sm-3");
        $("#FilterAreaAccordion").addClass("col-xs-3");



    }


});

